import React, { createRef } from 'react';
import { bindActionCreators } from 'redux';
import NESAHeader from '../Inc/NESAHeader';
import NESAFooter from '../Inc/NESAFooter';
import warningAlert from './warning-alert.png';
import InputMask from 'react-input-mask'
import * as actions from '../../actions/index';
import moment from 'moment';
import { history } from '../../container/History';
import { CheckCircleTwoTone } from '@ant-design/icons';
import { Steps, Button, Tooltip, Spin, Row, Typography, Switch, Col, Card, Modal, Form, Input, Radio, Checkbox, Select, Icon, Divider } from 'antd';
import { connect } from 'react-redux';
import Iframe from '../HOC/iframe'

import ScoutsPrimaryOrAlternateAddress from './ScoutsAddress';

import NewEagleGreetingsModal from './NewEagleGreetingsModal';

import CustomPopupModal from '../Inc/customPopupModal'
import FullPageSpinner from '../Inc/FullPageSpinner'


const FormItem = Form.Item;
const Step = Steps.Step;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const CHASE_URL = process.env.REACT_APP_CHASE
const PENDING_MEMBERSHIP_TEXT = process.env.REACT_APP_PENDING_MEMBERSHIP_TEXT;
const CONFIRM_MEMBERSHIP_TEXT = process.env.REACT_APP_CONFIRM_MEMBERSHIP_TEXT;

const RENEW_PURCHASE = JSON.parse(process.env.REACT_APP_RENEW_PURCHASE);
const { Text } = Typography;
const NESA_MID = process.env.REACT_APP_NESA_MID;
const TRANSACTION_FEE = process.env.REACT_APP_TRANSACTION_FEE;
let BackBtn = false;

const membershipLevels = [
    { label: '5 Year', value: "NESA-5Year" },
    { label: 'LifeTime', value: 'NESA-Lifetime' },
];

const failedToLoadLookup_Popup_primaryConent = "We were unable to load required"
const failedToLoadLookup_secondaryConent = "Please try again."

const deceasedPopup_primaryConent = "We’re sorry, but NESA memberships cannot be issued in the name of a deceased individual."
const deceasedPopup_secondaryConent = "If you have any questions or need further assistance, please contact us at NESA@scouting.org."

class RenewMembershipForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            scouts_DOB: '',
            userDetails: {},
            selectedRecord: undefined,
            scoutsCountry: '616',
            hideNext: true,
            currentMembershipType: "",
            selectedMembershipType: "",
            isDeceasedPerson: false,
            isFiveYearPlan: false,
            isLifetimePlan: false,
            personGUID: "",
            CurrentMembershipExpiryDate: '',
            proratedAmount: 0,
            adjustedRenewalPrice: 0,
            TotalAmount: 0,
            // SelectedMembership: 0,
            SelectedMembershipID: 0,
            SelectedMembershipName: '',
            SelectedMembershipPrice: 0,
            shipping_handlingCharge: '',
            isPayTransactionFees: false,
            ShowPaymentSummary: true,
            transactionFee: 0,
            showResultModal: false,
            NoResultsMatchProfile: false,
            NoMembershipFound_Modal: false,
            NoResultsFound: false,
            EagleResults: [],
            receipt_loading: false,
            ReceiptPara1: "",
            profilevalues: {},
            ReceiptPara2: "",
            minutes: 0,
            seconds: 20,
            ReceiptEmail: '',
            memberSelectedKey: 0,
            existingLifePlan: false,
            membershipRecords: {},
            PromocodeApplied: false,
            DiscountAmount: 0,
            DiscountCode: '',
            createdPayments: {},
            getValidEagleState: undefined,
            getValidEagleCity: undefined,
            isRedirectedFromGiftMembership: false,
            isShow_MissingFieldsPopup: false,
            yoursCountry: "616",
            isShippingAddress: false,
            // doesShowNewMemberGreetings: false,
            // isApplicableForNewEagle: false,
            lookupsLoaded: false,
            showLookupError: false,
            pageLoader: true,
            failedLookups: []
        };

        this.ethnicities = this.ethnicities.bind(this)
        window.showRenewReceiptComponent = this
        this.selectphonecountryIDRef = React.createRef();

    }

    componentDidMount = () => {
        this.props.actions.getProductPrice();
        this.props.actions.getNESAmembershiplevels();
        this.props.actions.getEthnicities();
        this.props.actions.getStates();
        this.props.actions.getCountries();
        this.props.actions.getPhoneCountries();
        if (this.props.location.state) {
            if (this.props.location.state.renewMembership && this.props.location.state.scouts_DOB && this.props.searchedEagle) {

                this.renewMembershipPlan(true, this.props.location.state.SelectedMembershipName == 'NESA 5Year' ? 'NESA-5Year' : 'NESA-Lifetime')
                this.setState({
                    scouts_DOB: this.props.location.state.scouts_DOB,
                })
                this.searchedEagle(this.props.searchedEagle)
                if (this.props.location.state.redirectedFrom === 'gift-membership') {
                    this.setState({
                        isRedirectedFromGiftMembership: true,
                    })
                }
            }
        }
    }

    componentDidUpdate(prevProps) {
  if (
    !prevProps.regError &&
    this.props.regError &&
    this.state.receipt_loading
  ) {
    this.setState({ receipt_loading: false });

    const { errorCode, message, errorDesc } = this.props.regError;

    Modal.error({
      title: `Error ${errorCode || ""}`,
      content: (
        <div>
          <p><b>{message || "Request failed"}</b></p>
          {errorDesc && <p>{errorDesc}</p>}
        </div>
      )
    });
  }
}

    show_NoResultsFound_Modal = () => {
        this.setState({
            NoResultsFound: true
        })
    }
    close_NoResultsFound_Modal = () => {
        if (this.props.location.state && this.props.location.state.redirectedFrom) {
            this.setState({
                NoResultsFound: false,
            });

            if (this.props.location.state.redirectedFrom === 'gift-membership') {
                history.push('/gift-membership');
            } else {
                history.push('/purchase-membership');
            }
        } else {
            this.setState({
                NoResultsFound: false,
                current: 0,
            });
        }

        // history.push('/my-profile')
    }

    close_NoMembershipFound_Modal = () => {
        this.setState({
            NoMembershipFound_Modal: false
        })
        history.push('/purchase-membership')
    }

    showResults = () => {
        this.setState({
            showResultModal: true
        })
    }

    closeResult = () => {
        this.setState({
            showResultModal: false
        })
    }
    closeNorecordsMatchProfile = () => {
        this.setState({
            NoResultsMatchProfile: false
        })
        history.push('/my-profile')
    }

    closeExistingLifePlanModal = () => {
        if (this.props.location.state && this.props.location.state.redirectedFrom) {
            this.setState({
                NoResultsFound: false,
            });

            if (this.props.location.state.redirectedFrom === 'gift-membership') {
                history.push('/gift-membership');
            } else {
                history.push('/purchase-membership');
            }
        } else {
            this.setState({
                existingLifePlan: false, 
                NoResultsFound: false,
                current: 0
            });
        }

        // history.push('/')
    }

    NoResultsMatchMyProfileAlert = () => {
        this.setState({
            NoResultsMatchProfile: true,
            showResultModal: false,
        })
    }
    getValidEagleStateHandler = (eagleState, eagleCity) => {
        let getValidEagleState, getValidEagleCity;
        let getEagleState = this.props.allstates.filter(state => {
            return state.short == eagleState
        })
        if (getEagleState.length == 0) {
            getValidEagleState = null;
            getValidEagleCity = null
        }
        else {
            getValidEagleState = eagleState;
            getValidEagleCity = eagleCity
        }

        return { getValidEagleState, getValidEagleCity }
    }

    retryToLoadFailedLookups = () => {
        if(this.props.ethnicitiesError) this.props.actions.getEthnicities();
        if(this.props.productpriceError) this.props.actions.getProductPrice();
        if(this.props.nesa_levelsError) this.props.actions.getNESAmembershiplevels();
        if(this.props.allstatesError) this.props.actions.getStates();
        if(this.props.countriesError) this.props.actions.getCountries();
        if(this.props.phonecodeError) this.props.actions.getPhoneCountries();

        this.setState({
            showLookupError: false,
            pageLoader: true
        })
    }

    SelectedMemberRecord = (record, i) => {
        //AAG-971 Remove 'Scout's Phone Number from NESA application process
        // let phoneCountryId = "", PhoneNumber = "";

        // if (record.phone.length == 13) {
        //     let getCountryShort = record.phone.slice(0, 3).toString();
        //     if (this.props.phonecode) {
        //         this.props.phonecode.map(code => {
        //             if (getCountryShort == code.short) {
        //                 phoneCountryId = code.id
        //             }
        //         })
        //     }
        //     PhoneNumber = record.phone.slice(3);
        // } else {
        //     PhoneNumber = record.phone;
        // }

        let getValidEagleDetails = this.getValidEagleStateHandler(record.eagleState, record.eagleCity)

        // const isApplicableForNewEagle = this.checkApplicableForNewEagle(record.eagleBoardReviewDate);

        this.setState({
            //     phoneCountryId,
            //     PhoneNumber,
            memberSelectedKey: i,
            selectedRecord: record,
            personGUID: record.personGuid,
            getValidEagleState: getValidEagleDetails.getValidEagleState,
            getValidEagleCity: getValidEagleDetails.getValidEagleCity,
            // doesShowNewMemberGreetings: isApplicableForNewEagle,
            // isApplicableForNewEagle
        });
    }

    renderSearchResults = () => {
        if (this.state.EagleResults.length !== 0) {
            return this.state.EagleResults.map((eagle, i) => {
                return (<div className={this.state.memberSelectedKey == i ? 'eagle-results-active' : 'eagle-results'}
                    key={i} onClick={() => {
                        if (eagle.isDeceased) {
                        this.setState({isDeceasedPerson: true})
                    } else {
                        this.SelectedMemberRecord(eagle, i)
                    } 
                }}
                >
                    <Row>
                        <Col xs={23}>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Scout Name: </b></span><span> {`${eagle.firstName} ${eagle.middleName} ${eagle.lastName}`} </span>
                                </Col>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Member ID: </b></span><span>   {eagle.memberId ? eagle.memberId : '---'}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Board of Review Date:  </b></span><span>  {eagle.eagleBoardReviewDate ? eagle.eagleBoardReviewDate : '---'}</span>
                                </Col>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Awarding Council: </b></span><span>  {eagle.awardingCouncilName ? eagle.awardingCouncilName : '---'} </span>
                                </Col>

                            </Row>
                            <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council Unit Number: </b></span><span> {eagle.eagleTroopNumber ? eagle.eagleTroopNumber : "---"}</span>
                                </Col>

                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council City: </b></span><span>  {eagle.eagleCity ? eagle.eagleCity : '---'}</span>
                                </Col>
                            </Row>
                            <Row>

                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council State: </b></span><span>  {eagle.eagleState ? eagle.eagleState : '---'} </span>
                                </Col>
                            </Row>
                            {/* <Row>
                                <Col xs={24} md={12} lg={12}>
                                    <span><b>Council State: </b></span><span>  {eagle.eagleState ? eagle.eagleState : '---'} </span>
                                </Col>
                            </Row> */}
                        </Col>
                        {
                            this.state.memberSelectedKey == i ?
                                <Col xs={1}>
                                    <i className="fa fa-check-circle margin-right-10 fa-2x SelectedRecord pointer" aria-hidden="true"></i>
                                </Col> : ''
                        }
                    </Row>
                </div>
                )
            });
        }
    }

    searchedEagle = (searchedEagle) => {

        let filterSearchedEagle;
        filterSearchedEagle = searchedEagle.filter(each => {
            return each.eagleBoardReviewDate != "" && each.eagleBoardReviewDate != null && each.eagleCertificationDate != "" && each.eagleCertificationDate != null && each.memberId != '' && each.memberId != null
        })
        if (this.props.allstates) {
            filterSearchedEagle.map(eachRec => {
                this.props.allstates.map(item => {
                    if (item.short == eachRec.state) {
                        eachRec.stateId = item.id
                    }
                })
            })
        }

        let length = filterSearchedEagle.length
        //AAG-971 Remove 'Scout's Phone Number from NESA application process
        // let phoneCountryId = ""
        // let PhoneNumber = ""
        // if (length > 0 && filterSearchedEagle[0].phone.length == 13) {
        //     let getCountryShort = filterSearchedEagle[0].phone.slice(0, 3).toString();
        //     if (this.props.phonecode) {
        //         this.props.phonecode.map(code => {
        //             if (getCountryShort == code.short) {
        //                 phoneCountryId = code.id
        //             }
        //         })
        //     }
        //     PhoneNumber = filterSearchedEagle[0].phone.slice(3);
        // } else if (length > 0) {
        //     PhoneNumber = filterSearchedEagle[0].phone.replace(/ /g, '');
        // }

        if (length === 0) {
            this.show_NoResultsFound_Modal();
        } else {
            this.setState({ NoResultsFound: false });
        }

        if (length == 1) {
            // const current = this.state.current + 1;
            // this.props.actions.getProfileInfo(filterSearchedEagle[0].personGuid)
            // this.props.actions.getAlumniEagleInfo(filterSearchedEagle[0].personGuid)
            if (filterSearchedEagle[0].isDeceased) {
                this.setState({
                    isDeceasedPerson: true
                })
            } else {
            let getValidEagleDetails = this.getValidEagleStateHandler(filterSearchedEagle[0].eagleState, filterSearchedEagle[0].eagleCity)

            // const isApplicableForNewEagle = this.checkApplicableForNewEagle(filterSearchedEagle[0].eagleBoardReviewDate);
                    
            this.props.actions.getNESARegistrations(filterSearchedEagle[0].personGuid, true);
            return this.setState(
                {
                    current: 1,
                    isDeceasedPerson: filterSearchedEagle[0].isDeceased,
                    personGUID: searchedEagle[0].personGuid,
                    EagleResults: filterSearchedEagle,
                    selectedRecord: filterSearchedEagle[0],
                    scoutsCountry: filterSearchedEagle[0].countryId,
                    //  phoneCountryId, //AAG-971 Remove 'Scout's Phone Number from NESA application process
                    //  PhoneNumber,
                    getValidEagleState: getValidEagleDetails.getValidEagleState,
                    getValidEagleCity: getValidEagleDetails.getValidEagleCity,
                    // doesShowNewMemberGreetings: isApplicableForNewEagle,
                    // isApplicableForNewEagle
                }
            );
            }
        }
        if (length > 1) {
            let getValidEagleDetails = this.getValidEagleStateHandler(filterSearchedEagle[0].eagleState, filterSearchedEagle[0].eagleCity)

            this.showResults()
            return this.setState({
                // showResultModal: true,
                // phoneCountryId, //AAG-971 Remove 'Scout's Phone Number from NESA application process
                // PhoneNumber,
                selectedRecord: filterSearchedEagle[0],
                scoutsCountry: filterSearchedEagle[0].countryId,
                EagleResults: filterSearchedEagle,
                personGUID: filterSearchedEagle[0].personGuid,
                getValidEagleState: getValidEagleDetails.getValidEagleState,
                getValidEagleCity: getValidEagleDetails.getValidEagleCity
            })
        }
        // if (length === 0)
        //     this.show_NoResultsFound_Modal()
    }

    componentWillReceiveProps = (nextprops) => {
        if (nextprops.ethnicitiesError || nextprops.productpriceError || nextprops.nesa_levelsError || nextprops.allstatesError || nextprops.countriesError || nextprops.phonecodeError){
            const failedLookups = [];
            if (nextprops.ethnicitiesError) failedLookups.push("Ethnicities")
            if (nextprops.productpriceError) failedLookups.push("Product Price")
            if (nextprops.nesa_levelsError) failedLookups.push("Nesa Levels")
            if (nextprops.allstatesError) failedLookups.push("States")
            if (nextprops.countriesError) failedLookups.push('Countries')
            if (nextprops.phonecodeError) failedLookups.push('Phonecode')
            this.setState({ showLookupError: true, pageLoader: false, failedLookups });
        }

        if (nextprops.allstates && nextprops.allstates.length > 0 &&
            nextprops.ethnicities && nextprops.ethnicities.length > 0 &&
            nextprops.countries && nextprops.countries.length > 0 &&
            nextprops.phonecode && nextprops.phonecode.length > 0 &&
            nextprops.productprice && nextprops.productprice.length > 0 &&
            nextprops.nesa_levels && nextprops.nesa_levels.length > 0) 
            {
            this.setState({ lookupsLoaded: true, showLookupError: false, pageLoader: false });
        }

        if (this.props.applingPromocode !== nextprops.applingPromocode) {
            if (nextprops.applingPromocode) {
                this.setState({
                    applingPromocode: true
                })
            }
            if (!nextprops.applingPromocode) {
                this.setState({
                    applingPromocode: false
                })
            }
        }
        if (this.props.PromocodeAdded !== nextprops.PromocodeAdded) {
            if (nextprops.PromocodeAdded) {
                // let TotalAmount = this.state.TotalAmount;
                // let DiscountAmount = (nextprops.PromocodeAdded).toFixed(2);
                // let membershipCost = parseFloat(parseFloat(this.state.remainingMembershipAmount) - parseFloat(DiscountAmount)).toFixed(2)

                // let transactionFee = (((parseFloat(membershipCost) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
                // let totalPrice = this.state.isPayTransactionFees ? (
                //     (parseFloat(TotalAmount) - parseFloat(DiscountAmount) - parseFloat(this.state.transactionFee)) + parseFloat(transactionFee) 
                // ) 
                // : (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
                // totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
                this.setState({
                    // transactionFee,
                    // TotalAmount: totalPrice,
                    PromocodeApplied: true,
                    PromocodeError: false,
                    // DiscountAmount: DiscountAmount,
                    // // TotalAmount: (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
                })
            }
        }
        if (this.props.shoppingCartList !== nextprops.shoppingCartList && nextprops.shoppingCartList != undefined) {
            if (Object.keys(nextprops.shoppingCartList).length != 0) {
                let transactionFee = 0;
                let shipping_handlingCharge = 0;
                let remainingMembershipAmount = 0;
                // let SelectedMembershipPrice = 0;
                let DiscountAmount = 0;
                let DiscountCode = '';
                nextprops.shoppingCartList.shoppingCart.map(cartList => {
                    if (cartList.feeStructureCode === "OLRADMIN") {
                        return transactionFee = parseFloat(cartList.amount).toFixed(2)
                    }
                    // if(cartList.feeStructureCode === "NESALIFECREDIT" ) {
                    //     return remainingMembershipAmount = parseFloat(cartList.amount).toFixed(2)
                    // }
                    if (cartList.feeStructureCode === 'NESA-5Year' || cartList.feeStructureCode === 'NESA-Lifetime' || cartList.feeStructureCode === "NESALIFECREDIT" || cartList.feeStructureCode === "NESA5NE-5Year" || cartList.feeStructureCode === "NESANE-LT") {
                        return remainingMembershipAmount = parseFloat(cartList.amount).toFixed(2)
                    }
                    if (cartList.product.includes('Shipping/Handling')) {
                        return shipping_handlingCharge = parseFloat(cartList.amount).toFixed(2)
                    }
                    if (cartList.feeStructureCode.includes('PROMO')) {
                        DiscountCode = cartList.promoCode
                        return DiscountAmount = parseFloat(cartList.amount).toFixed(2)

                    }
                })

                this.setState({
                    transactionFee,
                    remainingMembershipAmount,
                    shipping_handlingCharge,
                    // SelectedMembershipPrice,
                    DiscountAmount,
                    DiscountCode,
                    TotalAmount: nextprops.shoppingCartList.totalAmountDue
                })
            }


        }
        if (this.props.PromocodeRemoved !== nextprops.PromocodeRemoved) {
            if (nextprops.PromocodeRemoved) {
                this.props.form.setFieldsValue({
                    promocode: '',
                });
                // let transactionFee = (((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
                // let TotalAmount = (parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge) + (this.state.isPayTransactionFees ? parseFloat(transactionFee) : 0)).toFixed(2)

                // let TotalAmount = this.state.TotalAmount;
                // let DiscountAmount = (nextprops.PromocodeAdded).toFixed(2);
                // let membershipCost = parseFloat(parseFloat(this.state.SelectedMembershipPrice) - parseFloat(DiscountAmount)).toFixed(2)

                // let transactionFee = (((parseFloat(membershipCost) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
                // let totalPrice = this.state.isPayTransactionFees ? (
                //     (parseFloat(TotalAmount) - parseFloat(DiscountAmount) - parseFloat(this.state.transactionFee)) + parseFloat(transactionFee) 
                // ) 
                // : (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
                // totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
                this.setState({
                    // transactionFee,
                    // TotalAmount: TotalAmount,
                    // isPromocodeRemoved: true,
                    PromocodeError: false,
                    PromocodeApplied: false,
                    // isPromoCodeEditable: true,
                    DiscountCode: ''

                    // TotalAmount: (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
                })
            }
        }
        if (this.props.PromocodeError !== nextprops.PromocodeError) {
            if (nextprops.PromocodeError) {
                this.setState({
                    PromocodeError: true
                })
            }
        }
        if (this.props.response !== nextprops.response) {
            if (nextprops.response) {
                this.setState({
                    membershipRecords: nextprops.response,
                })
            }
        }
        if (this.props.giftResponse !== nextprops.giftResponse) {
            if (nextprops.giftResponse) {
                this.setState({
                    membershipRecords: nextprops.giftResponse,
                })
            }
        }
        if (this.props.createdPayments !== nextprops.createdPayments) {
            if (nextprops.createdPayments) {
                this.setState({
                    createdPayments: nextprops.createdPayments,
                    current: 3
                })
            }
        }
        if (this.props.initTransaction !== nextprops.initTransaction) {
            if (nextprops.initTransaction) {
                this.setState({
                    current: 4
                })
            }
        }
        if (this.props.nesa_reg !== nextprops.nesa_reg) {
            if (nextprops.nesa_reg.length != 0 && nextprops.nesa_reg != "error") {
                let haveLifeTime = nextprops.nesa_reg.find(item => item.programId.toString() == '32')
                if (haveLifeTime) {
                    this.setState({
                        existingLifePlan: true
                    })
                }
            }
            if (nextprops.nesa_reg.length == 0) {
                this.setState({
                    NoMembershipFound_Modal: true
                })
            }
        }
        if (this.props.searchedEagle !== nextprops.searchedEagle
            && (Array.isArray(nextprops.searchedEagle) && nextprops.searchedEagle.length > 0)
            && this.state.lookupsLoaded) {
            this.searchedEagle(nextprops.searchedEagle)
        }
        if (this.props.searchedEagle !== nextprops.searchedEagle
            && (Array.isArray(nextprops.searchedEagle) && nextprops.searchedEagle.length == 0)) {
            //show no record found popup
            this.NoResultsMatchMyProfileAlert()

        }
    }

    // renderLevels = () => {
    //     if (this.props.productprice_loading) {
    //         return <Row>
    //             <Col span={24}>
    //                 <Spin indicator={LoadingIcon} className="loading-state" tip="Loading NESA levels..." />
    //             </Col>
    //         </Row>
    //     }
    //     if (this.props.nesa_levels && this.props.productprice) {
    //         let nesalevels = this.props.nesa_levels
    //         let productprice = this.props.productprice;


    //         return nesalevels.map((k, index) => {
    //             let price = 0;
    //             let shipping_handlingCharge = 0;
    //             let shipping_StructureCode;
    //             let productname = (k.name).replace(/-/g, " ")
    //             productprice.map((j, index) => {
    //                 if (k.name == j.feeStructureCode) {
    //                     price = (Math.round(j.termFee * 100) / 100).toFixed(2);
    //                     if (k.name.includes("5Year")) { //if (k.name == "NESA-Silver-5Year") {
    //                         shipping_StructureCode = "NESA5SH"
    //                     } else if (k.name.includes("Lifetime")) { //  } else if (k.name == "NESA-Gold-Lifetime") {
    //                         shipping_StructureCode = "NESALIFESH"
    //                     }
    //                 }
    //             })

    //             productprice.map((j, index) => {
    //                 if (shipping_StructureCode == j.feeStructureCode) {
    //                     shipping_handlingCharge = (Math.round(j.termFee * 100) / 100).toFixed(2);
    //                 }
    //             })

    //             return <Col xs={24} sm={24} md={12} lg={12}>
    //                 <div className="membership-card">
    //                     <img src="../NESA.png" className='NESA-logo' />
    //                     <span className="membership-level">{productname == 'NESA 5Year' ? 'NESA 5-year' : productname}</span>
    //                     <span className="membership-price">${price}</span>
    //                     <Button className="membership-start" onClick={() => this.selectMembership(k.id, productname, Number(price), Number(shipping_handlingCharge))}>START</Button>
    //                 </div>
    //             </Col>
    //         })
    //     }
    // }

    checkApplicableForNewEagle = (eagleBOR) => {
        const currentDate = new Date();//AAG-1240 -  A NEW EAGLE STATUS IS NOW EXTENDED FOR A YEAR FROM THE BOR DATE.
        const newEagleApplicablePeriod = moment(eagleBOR).add(1, 'Year').subtract(1, 'day').format('MM/DD/YYYY');

        return Boolean(moment(currentDate).isSameOrAfter(eagleBOR) && moment(currentDate).isSameOrBefore(newEagleApplicablePeriod));

    }

    // closeNewMemberGreetingsModal = () => {
    //     this.setState({
    //         doesShowNewMemberGreetings: false,
    //     })
    //     // history.push('/')
    // }
    
    closeDeceasedPersonPopup = () => {
        this.setState({isDeceasedPerson: false})
}

    selectMembership = (selectedMembershipType) => {

        let price = 0;
        let shipping_handlingCharge = 0;
        let shipping_StructureCode;
        let productprice = this.props.productprice;
        let Selected_membershipId = '0';
        if (this.props.nesa_levels.length != 0 && productprice != 0) {
            this.props.nesa_levels.map((k, index) => {
                if (k.name == selectedMembershipType) {
                    return Selected_membershipId = k.id // membership level id
                }
                return
            })

            productprice.map((j, index) => {
                if (selectedMembershipType == j.feeStructureCode) {
                    price = (Math.round(j.termFee * 100) / 100).toFixed(2);
                    if (selectedMembershipType.includes("5Year")) { //if (selectedMembershipType == "NESA-Silver-5Year") {
                        shipping_StructureCode = "NESA5SH"
                    } else if (selectedMembershipType.includes("Lifetime")) { //  } else if (selectedMembershipType == "NESA-Gold-Lifetime") {
                        shipping_StructureCode = "NESALIFESH"
                    }
                }
            })

            productprice.map((j, index) => {
                if (shipping_StructureCode == j.feeStructureCode) {
                    shipping_handlingCharge = (Math.round(j.termFee * 100) / 100).toFixed(2);
                }
            })
        }


        return {
            shipping_handlingCharge, shipping_StructureCode, price, Selected_membershipId
        }
    }

    handleRenewalSummary = () => {
        let values = this.state.userDetails
        let isRush = false
        BackBtn = false
        // let person_ethnic = values.ethnic
        // let ethnicitiesArray = this.props.ethnicities
        // let ethnic = undefined;

        // // this.setState({
        // //     profilevalues: values
        // // })
        // ethnicitiesArray.map((k, index) => {
        //     if (k.short == person_ethnic) {
        //         values.ethnic = k.id
        //         if (this.state.ethnic == '') {
        //             ethnic = k.short
        //             // this.setState({
        //             //     ethnic: k.short
        //             // })
        //         }
        //     } else if (k.name == person_ethnic) {
        //         values.ethnic = k.id
        //         if (this.state.ethnic == '') {
        //             ethnic = k.short
        //             // this.setState({
        //             //     ethnic: k.short
        //             // })
        //         }
        //     }
        //     else {
        //         console.log('no ethnic found')
        //     }
        // })
        values.isUpdatePrimaryAddress = !this.state.isShippingAddress;
        let selectedRecord = { ...this.state.selectedRecord }
        selectedRecord.dob = this.state.scouts_DOB

        values.scout_state = this.state.getValidEagleState
        values.scout_city = this.state.getValidEagleCity

        this.setState({
            memberId: selectedRecord.memberId,
            firstname: selectedRecord.firstName,
            middlename: selectedRecord.middleName,
            lastname: selectedRecord.lastName,
            address1: values.addressline1 ? values.addressline1 : undefined,
            address2: values.addressline2 ? values.addressline2 : undefined,
            address3: values.addressline3 ? values.addressline3 : undefined,
            city: values.city ? values.city : undefined,
            zip: values.zipcode ? values.zipcode : undefined,
            data: values,
            userDetails: values,
            selectedRecord
        })

        //Troop Number added upto 4 digits
        // let TroopNumber = values.troopnumber
        // while (TroopNumber.length < 4) TroopNumber = "0" + TroopNumber;
        // values.troopnumber = TroopNumber

        //Transaction fee added
        values.isPayTransactionFees = this.state.isPayTransactionFees
        values.transactionFee = (((parseFloat(this.state.needToPay) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)

        if (
            (this.state.selectedRecord.email === undefined || this.state.selectedRecord.email === "") &&
            (this.state.userDetails.email === undefined || this.state.userDetails.email === "") && (this.state.userDetails.ScoutsEmail === undefined || this.state.userDetails.ScoutsEmail === "")
        ) {
            this.setState({
                isShow_MissingFieldsPopup: true,
            });
        } else {
            if ((this.state.userDetails.email === undefined || this.state.userDetails.email === "") && (this.state.selectedRecord.email != undefined || this.state.selectedRecord.email != "")) {
                this.state.userDetails.email = this.state.selectedRecord.email;
            }
            if ((this.state.selectedRecord.email === undefined || this.state.selectedRecord.email === "") && (this.state.userDetails.email != undefined || this.state.userDetails.email != "")) {
                this.state.selectedRecord.email = this.state.userDetails.email;
            }
            values.email = this.state.selectedRecord.email;
            this.state.isRedirectedFromGiftMembership ?
                this.props.actions.GiftMembership(this.state.SelectedMembershipID, values, false, parseFloat(this.state.needToPay), 'RENEW NESA', NESA_MID, selectedRecord, this.state.selectedRecord.email, 'GIFT-UPGRADE-NESA')
                :
                this.props.actions.RegisterMembership(values, selectedRecord, this.state.SelectedMembershipID, values, isRush, parseFloat(this.state.needToPay), 'RENEW NESA', NESA_MID, 'SELF-UPGRADE-NESA')

        }


        // this.props.actions.RegisterMembership(values, this.props.profileinfo, this.state.SelectedMembershipID, values, isRush, this.state.TotalAmount, "NESA", NESA_MID)
        // this.setState({
        //     ReceiptEmail: personemail.email,
        //     profilevalues: values,
        //     EagleInfo: values,
        //     ethnic
        // })

        this.setState({
            ShowPaymentSummary: false
        })
    }

    handleSubmit_MissingField = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let selectedRecord = { ...this.state.selectedRecord };
                selectedRecord.email = values.email;
                let userDetails = { ...this.state.userDetails };
                userDetails.email = values.email;

                this.setState({
                    selectedRecord,
                    userDetails,
                    isShow_MissingFieldsPopup: false
                })

                this.state.isRedirectedFromGiftMembership ?
                    this.props.actions.GiftMembership(this.state.SelectedMembershipID, values, false, parseFloat(this.state.needToPay), 'RENEW NESA', NESA_MID, selectedRecord, this.state.selectedRecord.email, "GIFT-UPGRADE-NESA")
                    :
                    this.props.actions.RegisterMembership(values, selectedRecord, this.state.SelectedMembershipID, values, false, parseFloat(this.state.needToPay), 'RENEW NESA', NESA_MID, "SELF-UPGRADE-NESA")
            }
        });
    };
    closeMissingFieldsPopup = () => {
        this.setState({
            isShow_MissingFieldsPopup: false
        })
    }

    next() {
        const current = this.state.current + 1;
        this.setState({ current });
        // this.props.actions.getEthnicities()
    }

    prev() {
        BackBtn = true;
        const current = this.state.current - 1;
        let length = this.state.EagleResults.length;
        if (current == 0 && length > 1) {
            this.setState({
                current,
                showResultModal: true
            });
        }
        else if (current == 0 && length == 1) {
            this.setState({
                current,
                NoResultsMatchProfile: true
            })
        } else if (current == 1 && length == 1) {
            this.setState({
                current,
                // NoResultsMatchProfile: true
            })
        }
        else if (current == 2 || current == 3 || current == 4 || current == 5) {
            let total = 0, transactionFee = 0, needToPay = 0;
            if (this.state.remainingMembershipAmount) {
                total = (((parseFloat(this.state.remainingMembershipAmount) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
                transactionFee = (((parseFloat(this.state.remainingMembershipAmount) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
                //remove shipping handling 
                needToPay = this.state.remainingMembershipAmount
            }
            //  else{
            //     total = (((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
            //     transactionFee =  (((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
            //     //remove shipping handling 
            //     needToPay = this.state.remainingMembershipAmount
            //  }


            this.setState({
                current: 2,
                DiscountAmount: 0,
                TotalAmount: total,
                needToPay,
                // transactionFee,
                PromocodeApplied: false,
                PromocodeError: false,
                // isPayTransactionFees: false,
            })
        }
        else {
            this.setState({ current });
        }
        // this.props.actions.getEthnicities()
    }
    ethnicities = () => {
        if (this.props.ethnicities) {
            let ethnicitiesArray = this.props.ethnicities
            return ethnicitiesArray.map((k, index) => {
                return (
                    <option key={index} value={k.short}>{k.name}</option>
                )
            })
        }
    }

    calculateFee = (yes) => {
        let needToPay = ''
        let transactionFee = this.state.transactionFee
        //Removing Transaction fees
        if (!yes) {
            // needToPay = (parseFloat(this.state.needToPay) - parseFloat(this.state.transactionFee)).toFixed(2)
            // this.setState({
            //     needToPay
            // })
            this.setState({
                transactionFee: 0.00
            })
        }

        // // let transactionFee = ((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100
        // let transactionFee = (((parseFloat(this.state.needToPay) + parseFloat(this.state.shipping_handlingCharge)) * parseFloat(TRANSACTION_FEE)) / 100).toFixed(2)
        // let totalPrice = this.state.isPayTransactionFees ? parseFloat(this.state.TotalAmount) - parseFloat(transactionFee) : parseFloat(this.state.TotalAmount) + parseFloat(transactionFee);
        // totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);

        //Adding Transaction fees
        if (yes) {
            // needToPay = (parseFloat(this.state.needToPay) + parseFloat(transactionFee)).toFixed(2)
            transactionFee = (((parseFloat(this.state.needToPay) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
        }

        this.setState({
            isPayTransactionFees: !this.state.isPayTransactionFees,
            transactionFee,
            //     TotalAmount: totalPrice,
            //     needToPay
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll(async (err, values) => {

            // let address = this.props.profileinfo.addresses.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
            // if (!address) {
            //     Modal.warning({
            //         title: 'Required!',
            //         content: 'You don\'t have any primary address. Please update the address information.',
            //     });
            //     return false
            // }
            // else
            if (!err) {
                let selectedRecord = this.state.selectedRecord
                let statesarray = this.props.allstates
                let currentDate = new Date()
                statesarray.map((k, index) => {
                    if (k.id == values.state) {
                        selectedRecord.state = k.short;
                        return values.stateName = k.short
                    }
                })

                if (this.props.location.state && (this.props.location.state.redirectedFrom === 'gift-membership' || this.props.location.state.redirectedFrom === 'purchase-membership')) {
                    this.setState({
                        memberId: selectedRecord.memberId,
                        firstname: selectedRecord.firstName,
                        middlename: selectedRecord.middleName,
                        lastname: selectedRecord.lastName,
                        current: 2,
                        userDetails: values,
                        selectedRecord
                    })
                } else {
                    let nesareg = this.props.nesa_reg ? this.props.nesa_reg : []
                    let nesalevels = this.props.nesa_levels ? this.props.nesa_levels : [];

                    let membership_Type = '';
                    let membershipId = '';
                    let expiryDate = '';

                    if (nesareg.length != 0 && nesalevels.length != 0 && nesareg != "error") {
                        let haveLifeTime = nesareg.find(item => item.programId.toString() == '32')
                        if (haveLifeTime) {
                            this.setState({
                                existingLifePlan: true
                            })
                        } else {
                            let membership_Type = 'NESA-Lifetime';
                            let membershipDetails = this.selectMembership(membership_Type);
                            let { shipping_handlingCharge, shipping_StructureCode, price, Selected_membershipId } = membershipDetails

                            let proratedAmount = this.getProratedAmount(membership_Type);
                            let needToPayAmount = (Math.round((price - parseFloat(proratedAmount)) * 100) / 100).toFixed(2);

                            let transactionFee = ((parseFloat(needToPayAmount) + parseFloat(shipping_handlingCharge)) * TRANSACTION_FEE) / 100;
                            transactionFee = (Math.round(transactionFee * 100) / 100).toFixed(2);
                            let totalPrice = parseFloat(needToPayAmount) + parseFloat(shipping_handlingCharge)

                            //adding membershiptype
                            values.MembershipType = Selected_membershipId

                            this.setState({
                                memberId: selectedRecord.memberId,
                                firstname: selectedRecord.firstName,
                                middlename: selectedRecord.middleName,
                                lastname: selectedRecord.lastName,
                                current: 2,
                                userDetails: values,
                                currentMembershipType: membership_Type,
                                isFiveYearPlan: membership_Type == 'NESA-5Year' ? true : false,
                                isLifetimePlan: membership_Type == 'NESA-Lifetime' ? true : false,
                                selectedMembershipType: membership_Type,
                                CurrentMembershipExpiryDate: expiryDate,
                                SelectedMembershipID: Selected_membershipId,
                                needToPay: needToPayAmount,
                                TotalAmount: totalPrice,
                                SelectedMembershipPrice: price,
                                transactionFee,
                                proratedAmount,
                                shipping_handlingCharge,
                                selectedRecord
                            })

                        }
                    }
                    else if (nesareg.length == 0) {
                        this.setState({
                            NoMembershipFound_Modal: true
                        })
                    }
                }
            }
        })
    }

    handlePromoSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                if (!this.state.PromocodeApplied) {
                    this.props.actions.ApplyPromocode(this.state.membershipRecords, values, this.state.isRedirectedFromGiftMembership ? "GIFT-UPGRADE-NESA" : 'SELF-UPGRADE-NESA')
                    this.setState({
                        DiscountCode: values.promocode
                    })
                } else {
                    this.props.actions.RemovePromocode(this.state.membershipRecords, values, this.state.isRedirectedFromGiftMembership ? "GIFT-UPGRADE-NESA" : 'SELF-UPGRADE-NESA')
                }
            }
        })
    }

    showReceipt = (RegID, response) => {
        setTimeout(
            function () {
                let userDetails = [...this.state.userDetails];
                userDetails.MembershipType = this.state.SelectedMembershipID;
                this.props.actions.getRegStatusandSendReceipt(RegID, this.state.userDetails, "RENEW-NESA", this.state.ReceiptEmail, response, this.state.isRedirectedFromGiftMembership, this.state.memberId)
            }
                .bind(this),
            15000
        );
    }

    newEagleDiscountMsg = () => {
        const { shoppingCartList } = this.props;
        if (shoppingCartList) {
            const isPromoCodeAdded = shoppingCartList.shoppingCart.some(cartList =>
                cartList.feeStructureCode === "NESA5NE-5Year" || cartList.feeStructureCode === "NESANE-LT"
            );
            if (isPromoCodeAdded) {
                return (
                    <div style={{ display: 'inline' }}>
                        <span className='Promocode-Added'>&#40;with New Eagle Discount&#41;</span>
                    </div>
                );
            }
        }
        return null;
    }

    renderPaymentSummary = () => {
        const { getFieldDecorator } = this.props.form;
        return <div className="payment-summary centered" style={{ marginBottom: '40px' }} >
            <Form className="search-form alumni-ui">
                <Row type="flex" justify="center" align="center">
                    <Col className="card-margin" span={24}>
                        <Card
                            className="centered"
                            title="SUMMARY"
                        >
                            <div className='upgrade-frame-card-padd' style={{ padding: "10px 30px" }}>
                                <Row >
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <div className="Summary-title-txt" style={{ fontSize: '14px' }}>Eagle Info</div>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                        <div className="verified"><Icon type="check-circle" /> Verified</div>
                                    </Col>

                                </Row>
                                <Row >
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <div className="summary-label-txt" style={{ fontSize: '14px' }} >{this.state.firstname} {this.state.middlename} {this.state.lastname}</div>
                                    </Col>
                                </Row>
                                <Row >
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                        <div className="summary-label-txt" style={{ fontSize: '14px' }} >{this.state.memberId}</div>
                                    </Col>
                                </Row>
                                <Divider style={{ margin: '10px 0px' }} />

                                <Row >
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <div className="Summary-title-txt" style={{ fontSize: '14px' }}>LEVEL</div>
                                    </Col>
                                    {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
<div className="verified"><Icon type="check-circle" /> {this.state.selectedMembershipType}</div>
</Col> */}

                                </Row>
                                <Row >
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <div className="summary-label-txt" style={{ fontSize: '14px' }} >{this.state.selectedMembershipType} {this.newEagleDiscountMsg()}</div>
                                    </Col>

                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                        <div className="summary-label-txt">$ {this.state.remainingMembershipAmount}</div>
                                    </Col>
                                </Row>
                                <Divider style={{ margin: '10px 0px' }} />

                              
                                        <Form onSubmit={this.handlePromoSubmit}>
                                            <div className='promotions'>
                                                <Row type='flex' align='middle'>
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                        <div className="summary-label-txt">Promotion code</div>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                        {getFieldDecorator('promocode', {
                                                            initialValue: "",
                                                            rules: [{ required: false }],
                                                        })(
                                                            <Input addonAfter={!this.state.PromocodeApplied ? <Button type="primary" loading={this.state.applingPromocode} htmlType='submit' icon="check">Apply</Button> : <Button style={{ backgroundColor: "#e60b2f", color: "#fff", borderColor: "transparent", }} htmlType='submit' loading={this.state.applingPromocode} icon="close" >  Remove </Button>} size="small" className='promocodeInput' placeholder="Code" />
                                                        )}
                                                    </Col>
                                                </Row>
                                                <Row type='flex' align='middle' justify='end'>
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                        {(this.state.PromocodeError && !this.state.PromocodeApplied) && <Text type="danger"><Icon type="info-circle" />  {this.props.PromocodeError ? this.props.PromocodeError.errorDesc ? this.props.PromocodeError.errorDesc : this.props.PromocodeError : "Invalid Promo Code!"}</Text>}
                                                        {this.state.PromocodeApplied && <Text type="success"><Icon type="check-circle" /> Promo Code added successfully!</Text>}
                                                    </Col>
                                                </Row>
                                                {this.state.DiscountAmount != 0 && <Row >
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                        <div className="summary-label-txt" style={{ fontSize: '14px' }} >Discount Amount</div>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                        <div className="summary-label-txt green-txt"> -$ {this.state.DiscountAmount}</div>
                                                    </Col>
                                                </Row>}
                                            </div>
                                            {this.state.PromocodeApplied && <Row >
                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                    <div className="summary-label-txt" style={{ fontSize: '14px' }} >Membership Cost</div>
                                                </Col>

                                                <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                    <div className="summary-label-txt">$ {parseFloat(parseFloat(this.state.remainingMembershipAmount) - parseFloat(this.state.DiscountAmount)).toFixed(2)}</div>
                                                </Col>
                                            </Row>}
                                        </Form>
                                        <Divider style={{ margin: '10px 0px' }} />
                                   
                                
                                <Row >
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <div className="summary-label-txt" style={{ fontSize: '14px' }} >{this.state.selectedMembershipType} Shipping/Handling</div>
                                    </Col>

                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                        <div className="summary-label-txt">$ {this.state.shipping_handlingCharge}</div>
                                    </Col>
                                </Row>

                                {this.state.isPayTransactionFees && <Row type="flex" justify="space-between" align="center">
                                    <Col span={18}>
                                        <span className="label-txt" style={{ fontSize: '14px' }} >Transaction Fees</span>
                                    </Col>
                                    <Col span={6} className="right">
                                        <span className="summary-price" style={{ fontSize: '14px' }}>$ {this.state.transactionFee}</span>
                                    </Col>
                                </Row>}
                                <Divider style={{ margin: '10px 0px' }} />

                                <Row style={{ display: 'flex', alignItems: 'center' }} className='total-charge'>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <div className="summary-label-txt" style={{ fontSize: '14px' }}>
                                            TOTAL CHARGE
                                        </div>
                                        {/* <div className="summary-label-txt" style={{ fontSize: '14px' }} ></div> */}
                                    </Col>

                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                        <div className="summary-price">$ {this.state.TotalAmount}</div>
                                    </Col>
                                </Row>


                                {/* 
<Row >
    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <div className="summary-label-txt" style={{ fontSize: '14px' }} >{this.state.firstname} {this.state.middlename} {this.state.lastname}</div>
    </Col>
</Row> */}
                                {/* <Row style={{ display: 'flex', justifyContent: 'center' }}>
    <Col className='xs-center sm-center' xs={14} sm={14} md={8} lg={8} xl={8}>
        {this.renderSearchButton()}
    </Col>
</Row> */}
                            </div>

                        </Card>
                    </Col>
                </Row>

                <div className="steps-action centered" style={{ width: '100%' }}>
                    <Row style={{ position: "unset" }}>
                        <Col xs={24} sm={24} md={14} lg={14} xl={14}  >
                            <div className="text-result pointer"
                                style={{ marginTop: "55px", marginBottom: '55px' }}
                                onClick={() => {
                                    // let total = (Math.round((parseFloat(this.state.needToPay) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
                                    // this.setState({
                                    //     current: 1,
                                    //     ShowPaymentSummary: true,
                                    //     isPayTransactionFees: false,
                                    //     TotalAmount: total
                                    // })
                                    this.prev()
                                }}><i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to Eagle Info</div>
                        </Col>
                        {/* <Col className='xs-center sm-center ' xs={24} sm={24} md={14} lg={14} xl={14} offset={2}>
                            <FormItem>
                                <Button type="primary" style={{ width: '100%' }} className='back-btn' onClick={() => this.prev()}>This is not me</Button>
                            </FormItem>
                        </Col> */}
                        <Col className='xs-center sm-center' xs={24} sm={24} md={8} lg={8} xl={8} offset={1}>
                            <FormItem>
                                <Button type="primary" style={{ width: '100%' }} className='submit-btn gift-paynow' id='goToCart-btn' loading={this.props.initloading} onClick={() => this.handlePaymentSummary()} > Pay Now</Button>
                            </FormItem>
                        </Col>
                    </Row>
                </div>
            </Form>
        </div>
    }

    handlePaymentSummary = () => {
        const isShippingAddress  = this.state.isRedirectedFromGiftMembership ? this.state.isRedirectedFromGiftMembership : this.state.isShippingAddress;
        const email  = this.state.isRedirectedFromGiftMembership ? this.state.userDetails.g_email : this.state.userDetails.email;
        this.props.actions.InitOrbitalPayments(this.props.shoppingCartList.totalAmountDue, 'RENEW NESA', NESA_MID, this.state.membershipRecords, email, this.state.createdPayments, 
        isShippingAddress  //For Gift membership we don't allow the user to update home address while purchasing
        )
    }

    renderIframe = () => {
        if (this.props.initloading == true) {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Chase Payments..." />
                </Col>
            </Row>
        }
        else if (this.props.registration_loading) {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Please Wait..." />
                </Col>
            </Row>
        }
        else if (this.props.initTransaction) {
            return <Row className="chase-payment">
                <Col span={24}>
                    <Iframe src={`${CHASE_URL}` + this.props.initTransaction.uID} height="700px" width="100%" />
                </Col>
            </Row>
        }
        else {
            return <Row>
                <Col span={24} className="centered margin-top-30">
                    <div className="margin-bottom-20">Unable to load the payment form. Please try again.</div>
                    <Button type="primary" onClick={() => this.handlePaymentSummary()}>Try Again</Button>
                </Col>
            </Row>
        }
    }

    renderReceiptpage = () => {
        if (this.props.regstatus) {
            if (this.props.regstatus[0].applicationStatusId == "4") {
                this.setState({
                    ReceiptPara1: PENDING_MEMBERSHIP_TEXT
                })
            }
            if (this.props.regstatus[0].applicationStatusId == "21") {
                this.setState({
                    ReceiptPara1: CONFIRM_MEMBERSHIP_TEXT
                })
            }
            this.setState({
                current: 5
            })
        }
    }

    render_nonUSA_address = () => {

        const { getFieldDecorator } = this.props.form;
        const stateInputEle = () => { return <input maxLength={2} style={{ textTransform: 'uppercase' }} autoComplete={'off'} /> };

        return (<Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
            <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem
                        label="Your Country"
                    >
                        {getFieldDecorator('countryId', {
                            initialValue: this.state.scoutsCountry ? `${this.state.scoutsCountry}` : "616",
                            rules: [{ required: true, message: 'Enter Your Country!' }],
                        })(
                            <Select
                                // className={this.state.scoutsCountry ? 'input-disabled' : ''}
                                // disabled={this.state.scoutsCountry ? true : false}
                                showAction={['focus', 'click']}
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Select a Country"
                                optionFilterProp="children"
                                onChange={(e) => {
                                    this.setState({
                                        scoutsCountry: e,
                                    })
                                }}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                {this.countries()}
                            </Select>
                        )}
                    </FormItem>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label={(
                            <span>
                                Address Line 1&nbsp;
                                <Tooltip placement="top" title="Represents street address (2423 Brighton Rd; 17 Downing Street)Combine the normal 2 line address into a single address, separating the house unit from street address via comma (2423 Brighton Road, Apt. 3; 17 Downing Street, Section 7)">
                                    <Icon type="info-circle-o" />
                                </Tooltip>
                            </span>
                        )}
                    >
                        {getFieldDecorator('addressline1', {
                            initialValue: this.state.selectedRecord.address1 ? this.state.selectedRecord.address1 : "",
                            rules: [{ required: true, message: 'Enter Your Address!' }],
                        })(
                            <Input placeholder="Address Line 1"
                            // className={this.state.selectedRecord.address1 ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.address1 ? true : false}
                            />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        style={{ marginBottom: '0px' }}
                        label={(
                            <span>
                                Address Line 2&nbsp;
                                <Tooltip placement="top" title="Represents a unit, number or subset of the street address (Apt. 12; Section 3; Dept. 22)">
                                    <Icon type="info-circle-o" />
                                </Tooltip>
                            </span>
                        )}
                    //extra="City, Territory, Country"
                    >
                        {getFieldDecorator('addressline2', {
                            initialValue: this.state.selectedRecord.address2 ? this.state.selectedRecord.address2 : "",
                            rules: [{ required: false, message: 'Enter Your Address!' }],
                        })(
                            <Input placeholder="Address Line 2"
                            // className={this.state.selectedRecord.address2 ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.address2 ? true : false} 
                            />
                        )}
                    </FormItem>
                </Col>

            </Row>

            <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        style={{ marginBottom: '0px' }}
                        label={(
                            <span>
                                Address Line 3&nbsp;
                                <Tooltip placement="top" title="List the city, territory and country according to country standards (Southampton, SO53 5PD, UK; Vancouver">
                                    <Icon type="info-circle-o" />
                                </Tooltip>
                            </span>
                        )}
                        extra="City, Territory, Country"
                    >
                        {getFieldDecorator('addressline3', {
                            initialValue: this.state.selectedRecord.address3 ? this.state.selectedRecord.address3 : "",
                            rules: [{ required: true, message: 'Enter Your Address!' }],
                        })(
                            <Input placeholder="Address Line 3"
                            // className={this.state.selectedRecord.address3 ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.address3 ? true : false} 
                            />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label={"Postal Code"}
                    >
                        {getFieldDecorator('zipcode', {
                            rules: [{ required: true, max: 10, message: 'Enter Your ZIP Code!' }],
                        })(
                            <Input placeholder={"ZIP Code"} maxLength={10} />
                        )}
                    </FormItem>
                </Col>
                {/* //AAG-971 Remove 'Scout's Phone Number from NESA application process */}

                {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Phone"
                    >
                        {getFieldDecorator('phone', {
                            initialValue: this.state.selectedRecord.phone ? (this.state.PhoneNumber) ? this.state.PhoneNumber.toString() : this.state.selectedRecord.phone.toString() : '',
                            rules: [{ required: true, min: 10, max: 10, message: 'Enter Your Phone Number!' },
                            {
                                pattern: new RegExp("^[0-9]*$"),
                                message: "Phone Number must be all numeric!"
                            }],
                        })(
                            <Input
                                // className={this.state.PhoneNumber ? 'input-disabled' : ''}
                                // disabled={(this.state.PhoneNumber) ? true : false}
                                addonBefore={
                                    getFieldDecorator('phonecountryID', {
                                        rules: [{ required: true, message: 'Select Phone Country ID' }],
                                        initialValue: this.state.phoneCountryId ? `${this.state.phoneCountryId}` : "636",
                                        // initialValue:  "636",
                                    })(
                                        <Select style={{ width: 100 }} ref={this.selectphonecountryIDRef} onSelect={() => this.selectphonecountryIDRef.current.blur()}>
                                            {this.getPhoneCode()}
                                        </Select>
                                    )
                                } />
                        )}
                    </FormItem>
                </Col> */}
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Email"
                    >
                        {getFieldDecorator('email', {
                            initialValue: this.state.selectedRecord.email ? this.state.selectedRecord.email : "",
                            rules: [{ required: true, type: "email", message: 'Enter valid email address!' }]
                        })(
                            <Input placeholder="Email"
                            // disabled={this.state.selectedRecord.email ? true : false}
                            // className={this.state.selectedRecord.email ? 'input-disabled' : ''}
                            />
                        )}
                    </FormItem>
                </Col>

            </Row>

        </Row>
        )
    }

    getProratedAmount = (selectedMembershipType) => {
        let proratedAmount;
        if (selectedMembershipType == "NESA-Lifetime") {
            const currentDate = new Date();
            const eagleExpireDate = new Date(this.state.CurrentMembershipExpiryDate);
            const getDateOfCurrentDate = new Date().getDate();
            const getDateOfExpireDate = new Date(this.state.CurrentMembershipExpiryDate).getDate();
            // const expireLimit = 6;

            //var getMonths = eagleExpireDate.getMonth() - currentDate.getMonth() + 12 * (eagleExpireDate.getFullYear() - currentDate.getFullYear())
            //let monthDifference = getDateOfCurrentDate < getDateOfExpireDate ? getMonths + 1 : getMonths
            //const monthDifference = Math.max(
            //  (eagleExpireDate.getFullYear() - currentDate.getFullYear()) * 12 + eagleExpireDate.getMonth() - currentDate.getMonth(), 0
            // )

            let monthDifference = 0
            //calculating remaining months
            if (this.props.nesa_reg.length != 0) {
                this.props.nesa_reg.map((k, index) => {
                    if ((moment(new Date(k.effectiveDate)).isSameOrBefore(moment(currentDate)) && moment(new Date(k.expireDate)).isSameOrAfter(moment(currentDate)))) {
                        let Today = moment();

                        // Parse the dates using moment.js and specify the format
                        const startMoment = moment(Today.format("YYYY-MM-DD"));
                        const endMoment = moment(k.expireDate);

                        // Calculate the difference in months and remaining days
                        const diffMonths = endMoment.diff(startMoment, 'months');
                        const diffDays = Math.round(endMoment.diff(startMoment, 'days') % 30.44); // Assuming 30 days in a month


                        monthDifference += diffMonths
                        // If there are 15 or more days remaining, add an extra month
                        if (diffDays >= 15) {
                            monthDifference += 1
                        }
                    }
                    if (moment(new Date(k.effectiveDate)).isSameOrAfter(moment(currentDate))) {
                        const startMoment = moment(k.effectiveDate);
                        const endMoment = moment(k.expireDate);

                        // Calculate the difference in months and remaining days
                        const diffMonths = endMoment.diff(startMoment, 'months');
                        const diffDays = Math.round(endMoment.diff(startMoment, 'days') % 30.44); // Assuming 30 days in a month


                        monthDifference += diffMonths
                        // If there are 15 or more days remaining, add an extra month
                        if (diffDays >= 15) {
                            monthDifference += 1
                        }
                    }
                })
            }

            monthDifference = (monthDifference > 120) ? 120 : monthDifference;
            proratedAmount = (Math.round((Number(monthDifference) * 1.6666667) * 100) / 100).toFixed(2) // ($100 divided by 60 months = $1.6666667/ month)

        } else {
            proratedAmount = (Math.round(0 * 100) / 100).toFixed(2)
        }

        return proratedAmount;
    }

    renewMembershipPlan = (value, selectedMembershipType) => {
        if (value) {
            // console.log('Five years plan selected');
            let selectedMembershipDetails = this.selectMembership(selectedMembershipType)
            let { shipping_handlingCharge, price, Selected_membershipId } = selectedMembershipDetails

            let proratedAmount = this.getProratedAmount(selectedMembershipType);
            let needToPayAmount = (Math.round((price - parseFloat(proratedAmount)) * 100) / 100).toFixed(2);
            let remainingMembershipAmount = needToPayAmount;

            let transactionFee = ((parseFloat(needToPayAmount) + parseFloat(shipping_handlingCharge)) * TRANSACTION_FEE) / 100;
            transactionFee = (Math.round(transactionFee * 100) / 100).toFixed(2);
            // let total = (Math.round((parseFloat(price) + parseFloat(shipping_handlingCharge)) * 100) / 100).toFixed(2);
            let totalPrice = (parseFloat(needToPayAmount) + parseFloat(shipping_handlingCharge)).toFixed(2);

            //Adding Transaction Amount 
            // if (this.state.isPayTransactionFees) needToPayAmount = parseFloat(parseFloat(needToPayAmount) + parseFloat(transactionFee)).toFixed(2)
            let userDetails = this.state.userDetails
            userDetails.MembershipType = Selected_membershipId
            this.setState({
                isFiveYearPlan: selectedMembershipType == 'NESA-5Year' ? true : false,
                isLifetimePlan: selectedMembershipType == 'NESA-Lifetime' ? true : false,
                selectedMembershipType: selectedMembershipType,
                SelectedMembershipID: Selected_membershipId,
                needToPay: needToPayAmount,
                TotalAmount: totalPrice,
                SelectedMembershipPrice: price,
                transactionFee,
                proratedAmount,
                shipping_handlingCharge,
                remainingMembershipAmount,
                userDetails
            })
        }
    }

    // renewLifeTimePlan = (value) => {
    //     // console.log('Lifetime plan selected');
    //     let  selectedMembershipDetails = this.selectMembership(value)
    //     let  { selectedMembershipType, shipping_handlingCharge, price, membershipId } = selectedMembershipDetails

    //     let proratedAmount = this.getProratedAmount(selectedMembershipType);
    //     let needToPayAmount;
    //     if (selectedMembershipType == 'NESA-Lifetime') {
    //         needToPayAmount = (Math.round((500 - parseFloat(proratedAmount)) * 100) / 100).toFixed(2);
    //     }
    //     else {
    //         needToPayAmount = (Math.round(price * 100) / 100).toFixed(2)
    //     }

    //     let transactionFee = ((parseFloat(price) + parseFloat(shipping_handlingCharge)) * TRANSACTION_FEE) / 100;
    //     transactionFee = (Math.round(transactionFee * 100) / 100).toFixed(2);
    //     let total = (Math.round((parseFloat(price) + parseFloat(shipping_handlingCharge)) * 100) / 100).toFixed(2);
    //     let totalPrice = parseFloat(needToPayAmount) + parseFloat(shipping_handlingCharge);

    //     this.setState({
    //         isFiveYearPlan: !this.state.isFiveYearPlan,
    //         isLifetimePlan: !this.state.isLifetimePlan,
    //         selectedMembershipType: selectedMembershipType,
    //         SelectedMembershipID: membershipId,
    //         needToPay: needToPayAmount,
    //         TotalAmount: totalPrice,
    //         SelectedMembershipPrice: price,
    //         transactionFee,
    //         proratedAmount,
    //         shipping_handlingCharge
    //     })
    // }

    renderPaymentButton = () => {

        if (this.props.response && !BackBtn) {
            this.next()
        }
        if (this.props.loading) {
            return <FormItem> <Button type="primary" style={{ width: '100%' }} className='submit-btn' loading > Loading ...</Button></FormItem>
        } else {
            if (this.state.hideNext) {
                return <FormItem> <Button type="primary" style={{ width: '100%' }} className='submit-btn' htmlType='submit' >NEXT</Button> </FormItem>
            }
        }
    }

    renderUpgradeNESAButton = () => {
        return <FormItem> <Button type="primary" style={{ width: '100%' }} loading={this.props.loading || this.props.gettingShoppingcart || this.props.giftLoading || this.props.creatingPayments} className='submit-btn renew-search-btn' id='goToCart-btn' htmlType='submit' >NEXT</Button> </FormItem>
    }

    render_USA_address = () => {

        const { getFieldDecorator } = this.props.form;
        const stateInputEle = () => { return <input maxLength={2} style={{ textTransform: 'uppercase' }} autoComplete={'off'} /> };

        return (<Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
            <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem
                        label="Your Country"
                    >
                        {getFieldDecorator('countryId', {
                            initialValue: this.state.scoutsCountry ? `${this.state.scoutsCountry}` : "616",
                            rules: [{ required: true, message: 'Enter Your Country!' }],
                        })(
                            <Select
                                // className={this.state.scoutsCountry ? 'input-disabled' : ''}
                                // disabled={this.state.scoutsCountry ? true : false}
                                showAction={['focus', 'click']}
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Select a Country"
                                optionFilterProp="children"
                                onChange={(e) => {
                                    this.setState({
                                        scoutsCountry: e,
                                    })
                                }}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                {this.countries()}
                            </Select>
                        )}
                    </FormItem>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Address Line 1"
                    >
                        {getFieldDecorator('addressline1', {
                            initialValue: this.state.selectedRecord.address1 ? this.state.selectedRecord.address1 : "",
                            rules: [{ required: true, message: 'Enter Your Address!' }],
                        })(
                            <Input placeholder="Address Line 1"
                            // className={this.state.selectedRecord.address1 ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.address1 ? true : false}
                            />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Address Line 2"
                    >
                        {getFieldDecorator('addressline2', {
                            initialValue: this.state.selectedRecord.address2 ? this.state.selectedRecord.address2 : "",
                            rules: [{ required: false, message: 'Enter Your Address!' }],
                        })(
                            <Input placeholder="Address Line 2"
                            // className={this.state.selectedRecord.address2 ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.address2 ? true : false} 
                            />
                        )}
                    </FormItem>
                </Col>

            </Row>

            <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Address Line 3"
                    >
                        {getFieldDecorator('addressline3', {
                            initialValue: this.state.selectedRecord.address3 ? this.state.selectedRecord.address3 : "",
                            rules: [{ required: false, message: 'Enter Your Address!' }],
                        })(
                            <Input placeholder="Address Line 3"
                            // className={this.state.selectedRecord.address3 ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.address3 ? true : false} 
                            />
                        )}
                    </FormItem>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your City"
                    >
                        {getFieldDecorator('city', {
                            initialValue: this.state.selectedRecord.city ? this.state.selectedRecord.city : "",
                            rules: [{ required: true, min: 2, message: 'Enter Your City!' }],
                        })(
                            <Input placeholder="City"
                            // className={this.state.selectedRecord.city ? 'input-disabled' : ''}
                            // disabled={this.state.selectedRecord.city ? true : false} 
                            />
                        )}
                    </FormItem>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your State"
                    >
                        {getFieldDecorator('state', {
                            initialValue: this.state.selectedRecord.stateId ? `${this.state.selectedRecord.stateId}` : "",
                            rules: [{ required: true, message: 'Enter Your State!' }],
                        })(
                            <Select
                                // disabled={this.state.selectedRecord.stateId ? true : false}
                                getInputElement={stateInputEle}
                                showAction={['focus', 'click']}
                                showSearch
                                style={{ width: '100%', textTransform: 'uppercase' }}
                                placeholder="Select a State"
                                optionFilterProp="children"
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                {this.statesID()}
                            </Select>
                        )}
                    </FormItem>
                </Col>


            </Row>

            <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your ZIP Code"
                    >
                        {getFieldDecorator('zipcode', {
                            initialValue: this.state.selectedRecord.zipCode ? this.state.selectedRecord.zipCode.toString() : "",
                            rules: [{ required: true, max: 5, message: 'Enter Your ZIP Code!' }],
                        })(
                            <Input placeholder="ZIP Code"
                                // className={this.state.selectedRecord.zipCode ? 'input-disabled' : ''}
                                // disabled={this.state.selectedRecord.zipCode ? true : false}
                                maxLength={5}
                            // style={this.state.selectedRecord.zipCode ? {background: '#f5f5f5 '} : ''}
                            />
                        )}
                    </FormItem>
                </Col>
                {/* //AAG-971 Remove 'Scout's Phone Number from NESA application process */}
                {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Phone"
                    >
                        {getFieldDecorator('phone', {
                            initialValue: this.state.selectedRecord.phone ? (this.state.PhoneNumber) ? this.state.PhoneNumber.toString() : this.state.selectedRecord.phone.toString() : '',
                            rules: [{ required: true, min: 10, max: 10, message: 'Enter Your Phone Number!' },
                            {
                                pattern: new RegExp("^[0-9]*$"),
                                message: "Phone Number must be all numeric!"
                            }],
                        })(
                            <Input
                                // className={this.state.PhoneNumber ? 'input-disabled' : ''}
                                // disabled={(this.state.PhoneNumber) ? true : false}
                                addonBefore={
                                    getFieldDecorator('phonecountryID', {
                                        rules: [{ required: true, message: 'Select Phone Country ID' }],
                                        initialValue: this.state.phoneCountryId ? `${this.state.phoneCountryId}` : "636",
                                        // initialValue:  "636",
                                    })(
                                        <Select style={{ width: 100 }} ref={this.selectphonecountryIDRef} onSelect={() => this.selectphonecountryIDRef.current.blur()}>
                                            {this.getPhoneCode()}
                                        </Select>
                                    )
                                } />
                        )}
                    </FormItem>
                </Col> */}
                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                    <FormItem hasFeedback
                        label="Your Email"
                    >
                        {getFieldDecorator('email', {
                            initialValue: this.state.selectedRecord.email ? this.state.selectedRecord.email : "",
                            rules: [{ required: true, type: "email", message: 'Enter valid email address!' }]
                        })(
                            <Input placeholder="Email"
                            // disabled={this.state.selectedRecord.email ? true : false}
                            // className={this.state.selectedRecord.email ? 'input-disabled' : ''}
                            />
                        )}
                    </FormItem>
                </Col>
            </Row>
        </Row>
        )
    }

    renderSearchButton = () => {
        if (this.props.response && !BackBtn) {
            this.next()
        }
        // if (this.props.loading) {
        //     return <FormItem> <Button type="primary" className='submit-btn' style={{ margin: 0, float: 'unset', width: "100%" }} loading > Loading ...</Button></FormItem>
        // } else {
        return <FormItem> <Button type="primary" className='submit-btn renew-search-btn' id='goToCart-btn' style={{ margin: 0, float: 'unset', width: "100%" }} htmlType='submit'>{this.props.searching ? "Searching..." : "SEARCH"}</Button> </FormItem>
        // }
    }

    countries = () => {
        if (this.props.countries) {
            const countriesarray = [...this.props.countries].sort((a, b) =>
                a.name.localeCompare(b.name)
            );

            return countriesarray.map((k) => (
                <Option key={k.id} value={`${k.id}`}>
                    {k.name}
                </Option>
            ));
        }

        return null;
    };

    statesID = () => {
        if (this.props.allstates) {
            return this.props.allstates.map((k) => (
                <Option key={k.id} value={`${k.id}`}>
                    {k.short}
                </Option>
            ));
        }

        return null;
    };

    getPhoneCode = () => {
        if (this.props.phonecode) {
            const phonecode = [...this.props.phonecode].sort((a, b) =>
                a.name.localeCompare(b.name)
            );

            return phonecode.map((k) => (
                <Option key={k.id} value={`${k.id}`}>
                    {k.name}
                </Option>
            ));
        }

        return null;
    };

    changeScoutsCountry = (e) => {
        this.setState({
            scoutsCountry: e,
        })
    }

    changeAlternateShippingAddress = (e) => {
        if (e.target.checked) {
            this.setState(({ isShippingAddress: true }))
        } else {
            this.setState(({ isShippingAddress: false }))
        }
    }

    renderPrimaryOrAlternateAddress = () => {

        return <ScoutsPrimaryOrAlternateAddress
            form={this.props.form}
            selectedRecord={this.state.selectedRecord}
            scoutsCountry={this.state.scoutsCountry}
            phoneCountryId={this.state.phoneCountryId}
            changeScoutsCountryEventHandler={this.changeScoutsCountry}
            isShippingAddress={this.state.isShippingAddress}
            changeAlternateShippingAddressEventHandler={this.changeAlternateShippingAddress}
            isRedirectedFromGift={this.state.isRedirectedFromGiftMembership}
        />
    }

    renderEagleInfo = () => {

        if (this.state.selectedRecord) {
            const { getFieldDecorator } = this.props.form;
            let eagleinfo = this.state.selectedRecord
            let isEagle = eagleinfo.eagleBoardReviewDate != null ? true : false
            let colSpan = this.state.isRedirectedFromGiftMembership ? 12 : 8;

            return <Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    {!this.state.isRedirectedFromGiftMembership && <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <FormItem
                            label={(
                                <span>
                                    Eagle Scout Member ID&nbsp;
                                    <Tooltip placement="top" title="Your MemberID associated with your BOR date">
                                        <Icon type="info-circle-o" />
                                    </Tooltip>
                                </span>
                            )}
                        >
                            {getFieldDecorator('memberid', {
                                initialValue: eagleinfo ? eagleinfo.memberId ? eagleinfo.memberId : '' : '',
                                // rules: [{ required: true, message: 'Enter Member ID!' }],
                            })(
                                <Input className={eagleinfo ? eagleinfo.memberId ? "input-disabled" : '' : ''} disabled={eagleinfo ? eagleinfo.memberId ? true : false : false} placeholder="Eagle Scout Member ID" />
                            )}
                        </FormItem>
                    </Col>}
                    <Col xs={24} sm={24} md={colSpan} lg={colSpan} xl={colSpan}>
                        <FormItem
                            label="Eagle Scout Board of Review Date"
                            hasFeedback
                            validateStatus={this.state.isVaildDate}
                            onClick={() => this.setState({ scouts_BOR: '-' })}
                        >
                            {getFieldDecorator('review_date', {
                                initialValue: eagleinfo ? eagleinfo.eagleBoardReviewDate ? moment(eagleinfo.eagleBoardReviewDate).format('MM/DD/YYYY') : '' : '',
                                rules: [
                                    { required: true, message: 'Enter Eagle Scout Board of Review Date!' },
                                    {
                                        pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                        message: `Please enter correct format MM/DD/YYYY Pattern`
                                    }
                                ],
                            })(
                                // <DatePicker disabled={isEagle} style={{ width: '100%' }} placeholder='MM/DD/YYYY' format="MM/DD/YYYY" />
                                <InputMask
                                    mask="99/99/9999"
                                    style={eagleinfo ? eagleinfo.eagleBoardReviewDate ? { background: '#f5f5f5 ' } : { background: '#fff' } : { background: '#fff' }}

                                    disabled={eagleinfo ? eagleinfo.eagleBoardReviewDate ? true : false : false}
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={this.state.scouts_BOR}
                                    className="ant-input"
                                    onChange={(e) => {
                                        this.format_Date(e, "BOR")
                                    }}
                                    render={(ref, props) => (
                                        <Input disabled={eagleinfo ? eagleinfo.eagleBoardReviewDate ? true : false : false} />
                                    )}
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={colSpan} lg={colSpan} xl={colSpan}>
                        <FormItem
                            label={(
                                <span>
                                    Eagle Scout Unit Number&nbsp;
                                    <Tooltip placement="top" title="Please Enter Four Digit Unit Number. Eg: 0001, 0018, 0234">
                                        <Icon type="question-circle-o" />
                                    </Tooltip>
                                </span>
                            )}
                        >
                            {getFieldDecorator('scout_unit', {
                                initialValue: eagleinfo ? eagleinfo.unitNumber ? eagleinfo.unitNumber : '' : "",
                                rules: [
                                    // { required: true },
                                    { max: 4, message: 'Unit Number must be four digits!' },
                                    {
                                        pattern: new RegExp("^[0-9]*$"),
                                        message: "Unit Number must be all numeric!"
                                    }],
                            })(
                                <Input  disabled={eagleinfo ? eagleinfo.unitNumber ? true : false : false} maxLength={4} placeholder="Eagle Scout Unit " />
                            )}
                        </FormItem>
                    </Col>
                </Row>

                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    <Col xs={24} sm={24} md={colSpan} lg={colSpan} xl={colSpan}>
                        <FormItem
                            label=" Eagle Scout Unit City"
                        >
                            {getFieldDecorator('scout_city', {
                                initialValue: isEagle ? eagleinfo.eagleCity : "",
                                rules: [{
                                    //  required: true,
                                    message: 'Enter Your Eagle Scout Unit City!'
                                }],
                            })(
                                <Input disabled={isEagle} className={isEagle ? "input-disabled" : ''} placeholder="Eagle Scout Unit City" />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={colSpan} lg={colSpan} xl={colSpan}>
                        <FormItem
                            label=" Eagle Scout Unit State"
                        >
                            {getFieldDecorator('scout_state', {
                                initialValue: isEagle ? eagleinfo.eagleState : "",
                                rules: [{
                                    //  required: true,
                                    message: 'Enter Your Eagle Scout Unit State!'
                                }],
                            })(
                                <Select
                                    disabled={isEagle}
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Select a State"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {this.statesID()}
                                </Select>
                            )}
                        </FormItem>
                    </Col>
                    {/* <Col xs={24} sm={24} md={8} lg={8} xl={8}> */}
                    {/* <FormItem
                        label="Eagle Council"
                    >
                        {getFieldDecorator('scout_council', {
                            initialValue: isEagle ? eagleinfo.eagleCouncilName : "",
                            // rules: [{ required: true, message: 'Enter your Eagle Scout Unit City!' }],
                        })(
                            <Input disabled={isEagle} className={isEagle ? "input-disabled" : ''} placeholder="Eagle Council Name" />
                        )}
                    </FormItem> */}
                    {/* </Col> */}
                </Row>
            </Row>
        }
        else {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Eagle information..." />
                </Col>
            </Row>
        }
    }

    handleSearchSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                //Checking for NESA ineligible applicant
                // if (this.props.profileinfo && this.props.profileinfo.profile && this.props.profileinfo.profile.ineligibleFlag === true){
                //     this.showIneligibleStatusModal();
                // }else{
                values.scout_dob = this.state.scouts_DOB
                this.props.actions.searchEagle(values)
                // this.setState({
                //     scouts_DOB: values.scout_dob
                // })
                // }
            }
        })
    }

    showLoadingReceipt = () => {
        this.setState({
            receipt_loading: true
        })
        this.loadingInterval = setInterval(() => {
            const { seconds, minutes } = this.state

            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }))
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(this.loadingInterval)
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59
                    }))
                }
            }
        }, 1000)
    }

    format_Date = (e, field) => {
        let val = e.target.value.split('/');
        let NumExp = /[0-9]/
        val[0] = NumExp.test(val[0]) ? val[0].startsWith('-') ? val[0].replace("-", '0') : val[0] : '';
        val[1] = NumExp.test(val[1]) ? val[1].startsWith('-') ? val[1].replace("-", '0') : val[1] : '';
        val = val.toString().replaceAll(',', '/')
        let hasNumber = /\d/;
        if (field == "DOB" && hasNumber.test(val)) {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    dob: val,
                });
            }, 0)
            this.setState({
                scouts_DOB: val
            })

        } else if (field == "BOR" && hasNumber.test(val)) {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    review_date: val,
                });
            }, 0)
        } else if (field == "scout_dob" && hasNumber.test(val)) {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    scout_dob: val,
                });
            }, 0)
            this.setState({
                scouts_DOB: val
            })
        }
        //  else if (field == "C_DATE" && hasNumber.test(val)) {
        //     setTimeout(() => {
        //         this.props.form.setFieldsValue({
        //             certificate_date: val,
        //         });
        //     }, 0)
        // }

    }

    renderPII = () => {
        if (this.props.searching) {
            return (
                <Row>
                    <Col span={24}>
                        <Spin
                            indicator={LoadingIcon}
                            className="loading-state"
                            tip="Loading Eagle information..."
                        />
                    </Col>
                </Row>
            );
        }
        if (this.state.selectedRecord) {
            const { getFieldDecorator } = this.props.form;
            let eagleinfo = this.state.selectedRecord;
            let ethnicShort = this.state.selectedRecord.ethnicity;
            let ethnicBackground = undefined;
            if (ethnicShort != "" && this.props.ethnicities) {
                this.props.ethnicities.map((each) => {
                    if (each.short == ethnicShort) {
                        ethnicBackground = each.name;
                    }
                });
            }
            return (
                <Row gutter={48} style={{ marginLeft: "0px", marginRight: "0px" }}>
                    <Row gutter={24} style={{ marginLeft: "0px", marginRight: "0px" }}>
                        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                            <FormItem hasFeedback label="Scout's First Name">
                                {getFieldDecorator("firstname", {
                                    initialValue: eagleinfo.firstName ? eagleinfo.firstName : "",
                                    rules: [{ message: "Enter Scout's First Name!" }],
                                })(
                                    <Input
                                        disabled
                                        placeholder="First Name"
                                        className="input-disabled"
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem hasFeedback label="Scout's middle Name">
                                {getFieldDecorator("middlename", {
                                    initialValue: eagleinfo.middleName
                                        ? eagleinfo.middleName
                                        : "",
                                    rules: [{ message: "Enter Scout's middle Name!" }],
                                })(
                                    <Input
                                        disabled
                                        placeholder="middle Name"
                                        className="input-disabled"
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem hasFeedback label="Scout's Last Name">
                                {getFieldDecorator("lastname", {
                                    initialValue: eagleinfo.lastName ? eagleinfo.lastName : "",
                                    rules: [{ min: 2, message: "Enter Scout's Last Name!" }],
                                })(
                                    <Input
                                        disabled
                                        placeholder="Last Name"
                                        className="input-disabled"
                                    />
                                )}
                            </FormItem>
                        </Col>
                    </Row>

                    {/* Hiding DOB, Gender and MemberID as per changes from AAG-1026 */}
                    {/* <Row gutter={24} style={{ marginLeft: "0px", marginRight: "0px" }}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem
                                hasFeedback
                                label="Scout's Date of Birth"
                                onClick={() => this.setState({ scouts_DOB_MaskChar: "-" })}
                            >
                                {getFieldDecorator("dob", {
                                    initialValue: this.state.scouts_DOB
                                        ? moment(this.state.scouts_DOB).format("MM/DD/YYYY")
                                        : "",
                                    rules: [
                                        { message: "Enter Date of Birth!" },
                                        {
                                            pattern:
                                                /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                            message: `Please enter correct format MM/DD/YYYY Pattern`,
                                        },
                                    ],
                                })(
                                    <InputMask
                                        style={{ background: "#f5f5f5 " }}
                                        className="input-disabled ant-input"
                                        disabled
                                        mask="99/99/9999"
                                        placeholder="MM/DD/YYYY"
                                        alwaysShowMask
                                        maskChar={this.state.scouts_DOB_MaskChar}
                                        onChange={(e) => {
                                            this.format_Date(e, "DOB");
                                        }}
                                        render={(ref, props) => (
                                            <Input className="input-disabled" disabled />
                                        )}
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem hasFeedback label="Scout's Member ID">
                                {getFieldDecorator("memberid", {
                                    initialValue: eagleinfo.memberId ? eagleinfo.memberId : "",
                                    // rules: [{  min: 2, message: 'Enter Scout\'s Member ID!' }],
                                })(
                                    <Input
                                        disabled
                                        placeholder="Member ID"
                                        className="input-disabled"
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem label="Gender">
                                {getFieldDecorator("gender", {
                                    initialValue: this.state.selectedRecord.gender
                                        ? this.state.selectedRecord.gender
                                        : "",
                                    rules: [{ required: true, message: "Enter Scout's Gender!" }],
                                })(
                                    <RadioGroup
                                        name="gender"
                                        disabled={
                                            this.state.selectedRecord.gender != "" ? true : false
                                        }
                                    >
                                        <Radio value="M">Male</Radio>
                                        <Radio value="F">Female</Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </Col>
                    </Row> */}
                    {/* //AAG-971 Remove 'Scout's Phone Number from NESA application process */}
                    {/* <Row gutter={24} style={{ marginLeft: "0px", marginRight: "0px" }}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem hasFeedback label="Scout's Phone">
                                {getFieldDecorator("phone", {
                                    initialValue: this.state.PhoneNumber
                                        ? this.state.PhoneNumber.toString()
                                        : "",
                                    rules: [
                                        {
                                            required: true,
                                            min: 10,
                                            max: 10,
                                            message: "Enter Scout's Phone Number!",
                                        },
                                        {
                                            pattern: new RegExp("^[0-9]*$"),
                                            message: "Phone Number must be all numeric!",
                                        },
                                    ],
                                })(
                                    <Input
                                        // className={this.state.PhoneNumber ? 'input-disabled' : ''}
                                        // disabled={(this.state.PhoneNumber) ? true : false}
                                        addonBefore={getFieldDecorator("phonecountryID", {
                                            initialValue: this.state.phoneCountryId
                                                ? `${this.state.phoneCountryId}`
                                                : "636",
                                            // initialValue:  "636",
                                        })(
                                            <Select
                                                style={{ width: 100 }}
                                                ref={this.selectphonecountryIDRef}
                                                onSelect={() =>
                                                    this.selectphonecountryIDRef.current.blur()
                                                }
                                            >
                                                {this.getPhoneCode()}
                                            </Select>
                                        )}
                                        placeholder="Phone"
                                    />
                                )}
                            </FormItem>
                        </Col>

                        <Col xs={24} sm={24} md={12} lg={6} xl={8}></Col>

                        <Col xs={24} sm={24} md={12} lg={6} xl={8}></Col>
                    </Row> */}
                </Row>
            );
        } else {
            return (
                <Row>
                    <Col span={24}>
                        <Spin
                            indicator={LoadingIcon}
                            className="loading-state"
                            tip="Loading Scout's Personal Information..."
                        />
                    </Col>
                </Row>
            );
        }
    };


    renderGiftMembershipFrames = () => {
        const { getFieldDecorator } = this.props.form;

        const stateInputEle = () => {
            return (
                <input
                    maxLength={2}
                    style={{ textTransform: "uppercase" }}
                    autoComplete={"off"}
                />
            );
        };

        return <div>
            <Col span={24} className="center">
                <span className="thank-you">
                    Thank you for your interest in supporting NESA, please
                    provide the scout's information for which you are
                    applying for a Gift-Membership.
                </span>
            </Col>
            {
                this.state.isRedirectedFromGiftMembership ?
                    <Col className="card-margin" span={24}>
                        <Card
                            className="centered"
                            title="Scout's Personal Information"
                        >
                            {this.renderPII()}
                        </Card>
                    </Col> : ''
            }

            <Col className="card-margin" span={24}>
                <Card
                    className="centered"
                    title="Eagle Scout Information"
                >
                    {this.renderEagleInfo()}
                </Card>
            </Col>

            <Col className="card-margin" span={24}>
                {this.renderPrimaryOrAlternateAddress()}
            </Col>

            {/* <Col className="card-margin" span={24}>
                                                <Card
                                                    className="centered"
                                                    title="Scout's Address Information"

                                                >
                                                    {this.state.scoutsCountry != '616' || this.state.scoutsCountry != 616 ?
                                                        this.render_nonUSA_address() : this.render_USA_address()
                                                    }

                                                </Card>
                                            </Col> */}

            <Col className="card-margin" span={24}>
                <Card className="centered" title="Your Information">
                    <Row
                        gutter={48}
                        style={{ marginLeft: "0px", marginRight: "0px" }}
                    >
                        <Row
                            gutter={24}
                            style={{ marginLeft: "0px", marginRight: "0px" }}
                        >
                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                <FormItem hasFeedback label="First Name">
                                    {getFieldDecorator("g_first_name", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Enter First Name!",
                                            },
                                        ],
                                    })(<Input placeholder="First Name" />)}
                                </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                <FormItem hasFeedback label="Last Name">
                                    {getFieldDecorator("g_last_name", {
                                        rules: [
                                            {
                                                required: true,
                                                min: 2,
                                                message: "Enter Last Name!",
                                            },
                                        ],
                                    })(<Input placeholder="Last Name" />)}
                                </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                <FormItem hasFeedback label="Phone" required={String(this.state.yoursCountry) !== "616"}>
                                    {getFieldDecorator("g_phone", {
                                                                        rules: [
                                                                            {
                                                                                validator: (rule, value, callback) => {

                                                                                    const country =
                                                                                        this.props.form.getFieldValue("g_countryId");

                                                                                    if (
                                                                                        String(country) !== "616" &&
                                                                                        !value
                                                                                    ) {
                                                                                        callback("Enter Your Phone Number!");
                                                                                        return;
                                                                                    }

                                                                                    callback();
                                                                                }
                                                                            },
                                                                            {
                                                                                min: 4,
                                                                                max: 10,
                                                                                message: "Enter Your Phone Number!"
                                                                            },
                                                                            {
                                                                                pattern: /^[0-9]*$/,
                                                                                message: "Phone Number must be all numeric!"
                                                                            }
                                                                        ],
                                                                    })(
                                        <Input
                                            addonBefore={getFieldDecorator(
                                                "g_phonecountryID",
                                                {
                                                    initialValue: "636",
                                                }
                                            )(
                                                <Select
                                                    style={{ width: 100 }}
                                                    ref={this.selectphonecountryIDRef}
                                                    onSelect={() => {
                                                        if (
                                                            this.selectphonecountryIDRef &&
                                                            this.selectphonecountryIDRef.current
                                                        ) {
                                                            this.selectphonecountryIDRef.current.blur();
                                                        }
                                                    }}
                                                >
                                                    {this.getPhoneCode()}
                                                </Select>
                                            )}
                                            placeholder="Phone"
                                        />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row
                            gutter={24}
                            style={{ marginLeft: "0px", marginRight: "0px" }}
                        >
                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                <FormItem hasFeedback label="Email">
                                    {getFieldDecorator("g_email", {
                                        rules: [
                                            {
                                                required: true,
                                                type: "email",
                                                message: "Enter valid email address!",
                                            },
                                        ],
                                    })(<Input placeholder="Email" value="" />)}
                                </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                <FormItem label="Country">
                                    {getFieldDecorator("g_countryId", {
                                        initialValue: this.state.yoursCountry
                                            ? this.state.yoursCountry
                                            : "616",
                                        rules: [
                                            {
                                                required: true,
                                                message: "Enter your Country!",
                                            },
                                        ],
                                    })(
                                        <Select
                                            showAction={["focus", "click"]}
                                            showSearch
                                            onChange={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                    yoursCountry: e,
                                                                                },
                                                                                () => {
                                                                                    if (String(e) === "616") {
                                                                                        this.props.form.setFields({
                                                                                            g_phone: {
                                                                                                value: this.props.form.getFieldValue("g_phone"),
                                                                                                errors: undefined,
                                                                                            },
                                                                                        });
                                                                                    } else {
                                                                                        this.props.form.validateFields(["g_phone"], {
                                                                                            force: true,
                                                                                        });
                                                                                    }
                                                                                }
                                                                            );
                                                                        }}
                                            style={{ width: "100%" }}
                                            placeholder="Select a Country"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.props.children
                                                    .toLowerCase()
                                                    .indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {this.countries()}
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                            {this.state.yoursCountry == "616" ||
                                this.state.yoursCountry == "" ? (
                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                    <FormItem hasFeedback label="Address Line 1">
                                        {getFieldDecorator("g_address_line_1", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Enter Address!",
                                                },
                                            ],
                                        })(<Input placeholder="Address Line 1" />)}
                                    </FormItem>
                                </Col>
                            ) : (
                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                    <FormItem
                                        hasFeedback
                                        label={
                                            <span>
                                                Address Line 1&nbsp;
                                                <Tooltip
                                                    placement="top"
                                                    title="Represents street address (2423 Brighton Rd; 17 Downing Street)Combine the normal 2 line address into a single address, separating the house unit from street address via comma (2423 Brighton Road, Apt. 3; 17 Downing Street, Section 7)"
                                                >
                                                    <Icon type="info-circle-o" />
                                                </Tooltip>
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator("g_address_line_1", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Enter Address!",
                                                },
                                            ],
                                        })(<Input placeholder="Address Line 1" />)}
                                    </FormItem>
                                </Col>
                            )}
                        </Row>
                        <Row
                            gutter={24}
                            style={{ marginLeft: "0px", marginRight: "0px" }}
                        >
                            {this.state.yoursCountry == "616" ||
                                this.state.yoursCountry == "" ? (
                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                    <FormItem hasFeedback label="Address Line 2">
                                        {getFieldDecorator("g_address_line_2", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Enter Address!",
                                                },
                                            ],
                                        })(<Input placeholder="Address Line 2" />)}
                                    </FormItem>
                                </Col>
                            ) : (
                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                    <FormItem
                                        hasFeedback
                                        style={{ marginBottom: "0px" }}
                                        label={
                                            <span>
                                                Address Line 2&nbsp;
                                                <Tooltip
                                                    placement="top"
                                                    title="Represents a unit, number or subset of the street address (Apt. 12; Section 3; Dept. 22)"
                                                >
                                                    <Icon type="info-circle-o" />
                                                </Tooltip>
                                            </span>
                                        }
                                    //extra="City, Territory, Country"
                                    >
                                        {getFieldDecorator("g_address_line_2", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Enter Address!",
                                                },
                                            ],
                                        })(<Input placeholder="Address Line 2" />)}
                                    </FormItem>
                                </Col>
                            )}
                            {this.state.yoursCountry == "616" ||
                                this.state.yoursCountry == "" ? (
                                <span>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                        <FormItem hasFeedback label="City">
                                            {getFieldDecorator("g_city", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        min: 2,
                                                        message: "Enter City!",
                                                    },
                                                ],
                                            })(<Input placeholder="City" />)}
                                        </FormItem>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                        <FormItem hasFeedback label="State">
                                            {getFieldDecorator("g_state", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Enter State!",
                                                    },
                                                ],
                                            })(
                                                <Select
                                                    getInputElement={stateInputEle}
                                                    showAction={["focus", "click"]}
                                                    showSearch
                                                    style={{
                                                        width: "100%",
                                                        textTransform: "uppercase",
                                                    }}
                                                    placeholder="Select a State"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.props.children
                                                            .toLowerCase()
                                                            .indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {this.statesID()}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </Col>
                                </span>
                            ) : (
                                <span>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                        <FormItem
                                            hasFeedback
                                            style={{ marginBottom: "0px" }}
                                            label={
                                                <span>
                                                    Address Line 3&nbsp;
                                                    <Tooltip
                                                        placement="top"
                                                        title="List the city, territory and country according to country standards (Southampton, SO53 5PD, UK; Vancouver"
                                                    >
                                                        <Icon type="info-circle-o" />
                                                    </Tooltip>
                                                </span>
                                            }
                                            extra="City, Territory, Country"
                                        >
                                            {getFieldDecorator("g_address_line_3", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Enter Address!",
                                                    },
                                                ],
                                            })(
                                                <Input placeholder="Address Line 3" />
                                            )}
                                            </FormItem>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                            <FormItem hasFeedback
                                                label={"Postal Code"}
                                            >
                                                {getFieldDecorator('g_zip_code', {
                                                    rules: [{ required: true, max: 10, message: 'Enter Your ZIP Code!' }],
                                                })(
                                                    <Input placeholder={"ZIP Code"} maxLength={10} />
                                                )}
                                            </FormItem>
                                        </Col>
                                </span>
                            )}
                            {this.state.yoursCountry == "616" ||
                                (this.state.yoursCountry == "" && (
                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                        <FormItem hasFeedback label="ZIP Code">
                                            {getFieldDecorator("g_zip_code", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        // pattern: this.state.ZipCodePattern ,
                                                        message: "Enter ZIP Code!",
                                                    },
                                                ],
                                            })(
                                                <InputMask
                                                    // mask="******" // (alpha/ numeric)
                                                    // mask="99999" // (numeric)
                                                    placeholderChar=""
                                                    className="ant-input"
                                                    render={(ref, props) => (
                                                        <Input placeholder="ZIP Code" />
                                                    )}
                                                />
                                            )}
                                        </FormItem>
                                    </Col>
                                ))}
                        </Row>
                        {this.state.yoursCountry == "616" ||
                            this.state.yoursCountry == "" ? (
                            <Row
                                gutter={24}
                                style={{
                                    marginLeft: "0px",
                                    marginRight: "0px",
                                }}
                            >
                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                    <FormItem hasFeedback label="ZIP Code">
                                        {getFieldDecorator("g_zip_code", {
                                            rules: [
                                                {
                                                    required: true,
                                                    max: 5,
                                                    min: 5,
                                                    message: "Enter ZIP Code!",
                                                },
                                            ],
                                        })(
                                            <InputMask
                                                // mask="*** ***" // (alpha/ numeric)
                                                mask="99999" // (alpha/ numeric)
                                                placeholderChar=""
                                                className="ant-input"
                                                render={(ref, props) => (
                                                    <Input placeholder="ZIP Code" />
                                                )}
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                        ) : null}
                    </Row>
                </Card>
            </Col>
        </div>
    }


    renderScoutsInfo = () => {
        if (this.state.selectedRecord) {
            const { getFieldDecorator } = this.props.form;
            let eagleinfo = this.state.selectedRecord

            let ethnicShort = this.state.selectedRecord.ethnicity;
            let ethnicBackground = undefined;
            if (ethnicShort != "" && this.props.ethnicities) {
                this.props.ethnicities.map(each => {
                    if (each.short == ethnicShort) {
                        ethnicBackground = each.name
                    }
                })
            }
            return (<Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <FormItem hasFeedback
                            label="Your First Name"
                        >
                            {getFieldDecorator('firstname', {
                                initialValue: eagleinfo.firstName ? eagleinfo.firstName : '',
                                rules: [{ message: 'Enter Scout\'s First Name!' }],
                            })(
                                <Input disabled placeholder="First Name" className="input-disabled" />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Middle Initial"
                        >
                            {getFieldDecorator('middlename', {
                                initialValue: eagleinfo.middleName ? eagleinfo.middleName : '',
                                rules: [{ message: 'Enter Scout\'s Middle Name!' }],
                            })(
                                <Input disabled placeholder="Middle Name" className="input-disabled" />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Last Name"
                        >
                            {getFieldDecorator('lastname', {
                                initialValue: eagleinfo.lastName ? eagleinfo.lastName : '',
                                rules: [{ min: 2, message: 'Enter Scout\'s Last Name!' }],
                            })(
                                <Input disabled placeholder="Last Name" className="input-disabled" />
                            )}
                        </FormItem>
                    </Col>
                </Row>
                {!this.state.isRedirectedFromGiftMembership &&
                    <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem hasFeedback
                                label="Your Date of Birth"
                                onClick={() => this.setState({ scouts_DOB_MaskChar: '-' })}
                            >
                                {getFieldDecorator('dob', {
                                    initialValue: this.state.scouts_DOB ? moment(this.state.scouts_DOB).format('MM/DD/YYYY') : '',
                                    rules: [{ message: 'Enter Date of Birth!' }],
                                })(
                                    <InputMask
                                        style={{ background: '#f5f5f5 ' }}
                                        className="input-disabled ant-input"
                                        disabled
                                        mask="99/99/9999"
                                        placeholder='MM/DD/YYYY'
                                        alwaysShowMask
                                        maskChar={this.state.scouts_DOB_MaskChar}
                                        onChange={(e) => {
                                            this.format_Date(e, "DOB")
                                        }}
                                        render={(ref, props) => (
                                            <Input
                                                className="input-disabled" disabled
                                            />
                                        )} />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem hasFeedback
                                label="Your Member ID"
                            >
                                {getFieldDecorator('memberid', {
                                    initialValue: eagleinfo.memberId ? eagleinfo.memberId : '',
                                    // rules: [{  min: 2, message: 'Enter Scout\'s Member ID!' }],
                                })(
                                    <Input disabled placeholder="Member ID" className="input-disabled" />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem
                                label="Gender"
                            >
                                {getFieldDecorator('gender', {
                                    initialValue: eagleinfo.gender ? eagleinfo.gender : '',
                                    rules: [{ required: true, message: 'Enter Scout\'s Gender!' }],
                                })(
                                    <RadioGroup name="gender" disabled={eagleinfo.gender != '' ? true : false}  >
                                        <Radio value="M">Male</Radio>
                                        <Radio value="F">Female</Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </Col>
                    </Row>}
                <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
                    {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem
                            label="Ethnic Background"
                        >
                            {getFieldDecorator('ethnic', {
                                initialValue: ethnicBackground ? ethnicBackground : '',
                                rules: [{ 
                                    // required: true,
                                     message: 'Enter Scout\'s Ethnic Background!' }],
                            })(
                                <Select style={{ width: '100%' }} disabled={ethnicBackground ? true : false} >
                                    {this.ethnicities()}
                                </Select>
                            )}
                        </FormItem>
                    </Col> */}

                    {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                        <FormItem hasFeedback
                            label="Your Certificate Date"
                            onClick={() => this.setState({ scouts_DOB_MaskChar: '-' })}
                        >
                            {getFieldDecorator('certificate_date', {
                                initialValue: '',
                                rules: [{ required: true, message: 'Enter the Certificate Date!' },
                                {
                                    pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                    message: `Please enter correct format MM/DD/YYYY Pattern`
                                }],
                            })(
                                <InputMask
                                    // style={{ background: '#f5f5f5 ' }}
                                    className="ant-input"
                                    mask="99/99/9999"
                                    placeholder='MM/DD/YYYY'
                                    alwaysShowMask
                                    maskChar={'-'}
                                    onChange={(e) => {
                                        this.format_Date(e, "C_DATE")
                                    }}
                                    render={(ref, props) => (
                                        <Input />
                                    )} />
                            )}
                        </FormItem>
                    </Col> */}
                </Row>
            </Row>)
        }
        else {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Your Personal Information..." />
                </Col>
            </Row>
        }
    }

    renderNESARegistrationStatus(nesa_reg, nesa_levels) {
        if (!Array.isArray(nesa_reg) || nesa_reg.length === 0 || !nesa_levels || nesa_levels.length === 0) {
            return null; // Return nothing if there are no valid records or levels
        }
    
        let lapseDate = moment().subtract(2, 'months').format('YYYY-MM-DD');
        let curDate = moment().format('YYYY-MM-DD');
    
        // Find the registration with the latest expireDate
        let latestRegistration = nesa_reg.reduce((latest, reg) => {
            return moment(reg.expireDate).isAfter(latest.expireDate) ? reg : latest;
        }, nesa_reg[0]);
    
        let effectiveDate = latestRegistration.effectiveDate;
        let expireDate = latestRegistration.expireDate;
    
        // Determine status based on effective and expire dates
        let status = '';
        if (moment(effectiveDate).isSame(expireDate) || moment(expireDate).isBefore(lapseDate)) {
            status = "expired";
        } else if (moment(curDate).isSameOrAfter(effectiveDate) && (!expireDate || moment(curDate).isBefore(expireDate))) {
            status = latestRegistration.isUpgrade && latestRegistration.programId === 32 ? 'upgrade' : 'active';
        } else if (moment(curDate).isBefore(effectiveDate)) {
            status = 'inactive';
        } else if (moment(expireDate).isSameOrAfter(lapseDate) && moment(expireDate).isSameOrBefore(curDate)) {
            status = 'lapsed';
        }
    
        // Identify the NESA level type by converting the string `nesa_levels.id` to a number for comparison
        const nesaLevelType = nesa_levels.find(level => Number(level.id) === latestRegistration.programId);
    
        // Render the status and membership type directly in the DOM
        return (
            <div>
                <p className='membership-statusANDtype'>{nesaLevelType ? nesaLevelType.name : ''} {status}</p>
            </div>
        );
    }
    

    render() {
        const { current } = this.state;
        const { minutes, seconds } = this.state
        const { getFieldDecorator } = this.props.form;
        const { nesa_reg, nesa_levels } = this.props;

        return (
            <div>
                <NESAHeader />

                <div className='step-widget'>
                    <div className='step-container'>

                        <div className='renew-membership-step step-background'>
                            <Row type="flex" align="center" justify="center">
                                <Steps current={current} labelPlacement="vertical">
                                    {/* <Step key="level" title="Eagle Level" /> */}
                                    <Step key="search" title="Eagle Search" />
                                    <Step key="eagle-info" title="Eagle Info" />
                                    <Step key="renewal-or-upgrade" title="Renewal or Upgrade" />
                                    <Step key="summary" title="Summary" />
                                    <Step key="payment" title="Payment" />
                                    <Step key="receipt" title="Receipt" />
                                </Steps>
                            </Row>
                        </div>

                        <div className="steps-content centered">

                            {this.state.current == 0 &&
                                <div className="centered renew" style={{ marginBottom: '40px' }} >
                                    <Form onSubmit={this.handleSearchSubmit} className="search-form alumni-ui renew-form">
                                        <Row type="flex" justify="center" align="start">
                                            <Col sm={24} xs={24} lg={24} xl={24} className="center">
                                                <img src="../NESA.png" className='NESA-logo' />
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className='welcome-text'> WELCOME </span>
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className='thank-you'>Thank you for your interest in supporting NESA</span>
                                            </Col>

                                            <Col className="card-margin search-alumni" span={24}>
                                                <Card
                                                    className="centered search-alumni-card"
                                                    title="YOUR PERSONAL INFORMATION"
                                                >
                                                    <Row gutter={48}>
                                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Your First Name"
                                                                hasFeedback
                                                            >
                                                                {getFieldDecorator('scout_first_name', {
                                                                    rules: [{ required: true, message: 'Enter Your First Name!' }],
                                                                })(
                                                                    <Input placeholder="First Name" />
                                                                )}
                                                            </FormItem>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Your Last Name"
                                                                hasFeedback
                                                            >
                                                                {getFieldDecorator('scout_last_name', {
                                                                    rules: [{ required: true, message: 'Enter Your Last Name!' }],
                                                                })(
                                                                    <Input placeholder="Last Name" />
                                                                )}
                                                            </FormItem>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Your Date of Birth"
                                                                hasFeedback
                                                                onClick={() => this.setState({ scouts_DOB_MaskChar: '-' })}
                                                            >
                                                                {getFieldDecorator('scout_dob', {
                                                                    initialValue: '',
                                                                    rules: [
                                                                        { required: true, message: 'Enter Your Date of Birth!' },
                                                                        {
                                                                            pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                                                            message: `Please enter correct format MM/DD/YYYY Pattern`
                                                                        }
                                                                    ],
                                                                })(

                                                                    <InputMask
                                                                        mask="99/99/9999"
                                                                        placeholder='MM/DD/YYYY'
                                                                        alwaysShowMask
                                                                        maskChar={this.state.scouts_DOB_MaskChar}
                                                                        className="ant-input"
                                                                        // value={this.state.scouts_DOB}
                                                                        onChange={(e) => {
                                                                            this.format_Date(e, 'scout_dob')
                                                                        }}
                                                                        render={(ref, props) => (
                                                                            <Input

                                                                            />
                                                                        )}
                                                                    />
                                                                )}
                                                            </FormItem>
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <Col className='xs-center sm-center' xs={14} sm={14} md={8} lg={8} xl={8}>
                                                            {this.renderSearchButton()}
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>

                                        </Row>
                                        <div className="steps-action center backto-levels">
                                            <Row style={{ position: "unset" }}>
                                                <Col xs={24} sm={24} md={9} lg={7} xl={7} className='nesa-org-width'  >
                                                    <div className="text-result pointer"
                                                        style={{ marginTop: "55px", marginBottom: '55px' }}
                                                        onClick={() => {
                                                            // if(this.props.location.state){
                                                            //     if (this.props.location.state.redirectedFrom) {
                                                            //         this.props.location.state.redirectedFrom === 'gift-membership' ? history.push('/gift-membership') : history.push('/purchase-membership')
                                                            //     }
                                                            // }
                                                            // else
                                                            window.location.assign('https://nesa.org/take-action/join-us/');
                                                        }}><i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to NESA.org/ Join
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Form>
                                    {/* <div className="steps-action centered backto-levels">
                                        <Row style={{ position: "unset" }}>
                                            <Col xs={24} sm={24} md={9} lg={7} xl={7}  >
                                                <div className="text-result pointer"
                                                    style={{ marginTop: "55px", marginBottom: '55px' }}
                                                    onClick={() => {
                                                        this.setState({
                                                            current: 0,
                                                        })
                                                    }}><i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to Eagle Levels</div>
                                            </Col>
                                        </Row>
                                    </div> */}
                                </div>
                            }
                            {this.state.current == 1 && 
                                <div className="centered steps-form" >
                                    <Form onSubmit={this.handleSubmit} className="purchase-form alumni-ui" style={{ width: '100%' }}>
                                        <Row type="flex" justify="center" align="center">
                                            <Col sm={24} xs={24} lg={24} xl={24} className="center">
                                                <img src="../NESA.png" className='NESA-logo' />
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className='welcome-text'> WELCOME </span>
                                            </Col>
                                            {this.state.isRedirectedFromGiftMembership ? this.renderGiftMembershipFrames() : <div>
                                                <Col span={24} className="center">
                                                    <span className='thank-you'>Thank you for your interest in supporting NESA</span>
                                                </Col>

                                                {/* AAG-1026 removed scouts personal information from purchase-renew workflow */}
                                                {/* <Col className="card-margin" span={24}>
                                                    <Card
                                                        className="centered"
                                                        title="Your Personal Information"
                                                    >
                                                        {this.renderScoutsInfo()}
                                                    </Card>
                                                </Col> */}

                                                <Col className="card-margin" span={24}>
                                                    <Card
                                                        className="centered"
                                                        title="Your Eagle Scout Information"
                                                    >
                                                        {this.renderEagleInfo()}
                                                    </Card>
                                                </Col>

                                                <Col className="card-margin" span={24}>
                                                    {this.renderPrimaryOrAlternateAddress()}
                                                </Col>

                                                {/* <Col className="card-margin" span={24}>
                                                    <Card
                                                        className="centered"
                                                        title="Your Address Information"

                                                    >
                                                        {this.state.scoutsCountry == '616' || this.state.scoutsCountry == 616 || this.state.scoutsCountry == '' ?
                                                            this.render_USA_address() : this.render_nonUSA_address()
                                                        }

                                                    </Card>
                                                </Col> */}


                                            </div>
                                            }

                                            <div className="steps-action centered" style={{ width: '100%' }}>
                                                <Row style={{ position: "unset" }}>
                                                    <Col xs={24} sm={24} md={9} lg={7} xl={7}  >
                                                        <div className="text-result pointer"
                                                            style={{ marginTop: "55px", marginBottom: '55px' }}
                                                            onClick={() => {
                                                                let total = (Math.round((parseFloat(this.state.needToPay) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
                                                                this.setState({
                                                                    // current : 0,
                                                                    DiscountAmount: 0,
                                                                    TotalAmount: total,
                                                                    PromocodeApplied: false,
                                                                    isPayTransactionFees: false,
                                                                })

                                                                if (this.props.location.state) {
                                                                    if (this.props.location.state.redirectedFrom) {
                                                                        this.props.location.state.redirectedFrom === 'gift-membership' ? history.push('/gift-membership') : history.push('/purchase-membership')
                                                                    }
                                                                } else this.setState({ current: 0 })

                                                            }}><i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to Eagle Search</div>
                                                    </Col>
                                                    <Col className='xs-center sm-center ' xs={24} sm={24} md={7} lg={7} xl={7} offset={2}>
                                                        <FormItem>
                                                            <Button type="primary" style={{ width: '100%' }} className='back-btn renew-search-btn' id='backToSearch-btn' onClick={() => this.prev()}>This is not me</Button>
                                                        </FormItem>
                                                    </Col>
                                                    <Col className='xs-center sm-center' xs={24} sm={24} md={7} lg={7} xl={7} offset={1}>
                                                        <FormItem>
                                                            {this.renderUpgradeNESAButton()}
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                            </div>


                                        </Row>

                                    </Form>
                                </div>
                            }
                            {
                                this.state.current == 2 &&
                                <div className='upgrade-frame centered ugrade-frame'>
                                    <Form className="upgrade-form alumni-ui">
                                        <Row type="flex" justify="center" align="center">
                                            <Col className="card-margin" span={24}>
                                                <Card
                                                    className="centered"
                                                    title="RENEWAL OR UPGRADE"
                                                >
                                                    <div className='upgrade-frame-card-padd' style={{ padding: "10px 30px" }}>
                                                        <Row >
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <div className="Summary-title-txt" style={{ fontSize: '14px' }}>Current Membership</div>
                                                            </Col>
                                                            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                                <div className="current-membership">
                                                                    <div className="EagleMembershipInfo">
                                                                        <span className="MembershipTypeInfoValue">{this.state.currentMembershipType}</span>
                                                                    </div>
                                                                </div>
                                                            </Col> */}
                                                        </Row>
                                                        <Row>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <div className="summary-label-txt" style={{ fontSize: '14px' }} >{this.state.firstname} {this.state.middlename} {this.state.lastname}</div>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <div className="summary-label-txt" style={{ fontSize: '14px' }}>{this.renderNESARegistrationStatus(nesa_reg, nesa_levels)}</div>
                                                            </Col>
                                                        </Row>
                                                        <Divider style={{ margin: '10px 0px' }} />

                                                        <Row>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <div className="Summary-title-txt" style={{ fontSize: '14px' }}>Renewal Membership</div>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <div className="renewal-plan">
                                                                    <div className='five-year-renewal'>
                                                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} style={{ textAlign: 'end' }}>
                                                                            <div className='plan-selected'>5 Year </div>
                                                                        </Col>
                                                                        <Col xs={2} sm={2} md={2} lg={2} xl={2} style={{ textAlign: 'end' }}>
                                                                            <Checkbox className='membershipType-custom-checkbox' checked={this.state.isFiveYearPlan} onChange={(e) => this.renewMembershipPlan(e.target.checked, "NESA-5Year")} />
                                                                        </Col>
                                                                        <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                                                                            <div className='plan-amount right'>{this.state.isFiveYearPlan ? `$ ${this.state.SelectedMembershipPrice}` : ''}</div>
                                                                        </Col>
                                                                    </div>
                                                                    <div className='life-time-renewal'>
                                                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} style={{ textAlign: 'end' }}>
                                                                            <div className='plan-selected'>Lifetime  </div>
                                                                        </Col>
                                                                        <Col xs={2} sm={2} md={2} lg={2} xl={2} style={{ textAlign: 'end' }}>
                                                                            <Checkbox className='membershipType-custom-checkbox' checked={this.state.isLifetimePlan} onChange={(e) => this.renewMembershipPlan(e.target.checked, "NESA-Lifetime")} />
                                                                        </Col>
                                                                        <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                                                                            <div className='plan-amount right'>{this.state.isLifetimePlan ? `$ ${this.state.SelectedMembershipPrice}` : ''}</div>
                                                                        </Col>
                                                                    </div>
                                                                </div>
                                                            </Col>

                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">


                                                            </Col>
                                                        </Row>

                                                        <Divider style={{ margin: '10px 0px' }} />

                                                        <Row>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <div className='Summary-title-txt Renewal-Note'>
                                                                    {
                                                                        this.state.selectedMembershipType === "NESA-5Year" ? `NOTE: When renewing a 5year membership, the new membership will begin, and 
                                                                        continue for 5years, on the day following the current membership's last day.`: "" ||
                                                                            this.state.selectedMembershipType === "NESA-Lifetime" ? `NOTE: If moving from a 5year to Lifetime, your Lifetime membership cost will be prorated,
                                                                        crediting your remaining 5year term` : ""
                                                                    }

                                                                </div>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right" style={{ color: 'red' }}>
                                                                {`$ ${this.state.proratedAmount}`}
                                                            </Col>
                                                        </Row>

                                                        <Divider style={{ margin: '10px 0px' }} />

                                                        <Row >
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <div className="Summary-title-txt" style={{ fontSize: '14px' }}>
                                                                    Optional Transaction Fee &nbsp;
                                                                    <Tooltip placement="bottom" title="Please consider covering the transaction fees for this membership purchase">
                                                                        <Icon type="info-circle-o" theme="twoTone" />
                                                                    </Tooltip>
                                                                </div>
                                                                {/* <div className="summary-label-txt" style={{ fontSize: '14px' }} ></div> */}
                                                            </Col>

                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                                <div className="summary-label-txt">
                                                                    <Switch checked={this.state.isPayTransactionFees} onChange={(e) => this.calculateFee(e)} />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        {/* <Row >
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <div className="summary-label-txt" style={{ fontSize: '14px' }} >Transaction Fees</div>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                                <div className="summary-label-txt">$ {this.state.transactionFee} </div>
                                                            </Col>
                                                        </Row> */}
                                                        <Divider style={{ margin: '10px 0px' }} />
                                                        <Row>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <div className='Renewal-Charge Summary-title-txt'>
                                                                    {
                                                                        this.state.selectedMembershipType == "NESA-5Year" ? "5year membership renewal charge" : this.state.selectedMembershipType == "NESA-Lifetime" ? "Lifetime Membership adjusted renewal charge" : ""
                                                                    }
                                                                </div>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="right">
                                                                <div className="summary-price">
                                                                    $ {this.state.needToPay}
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        {/* <Divider style={{margin: '10px 0px'}} /> */}


                                                    </div>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <div className="steps-action centered" style={{ width: '100%' }}>
                                            <Row style={{ position: "unset" }}>
                                                <Col xs={24} sm={24} md={14} lg={14} xl={14}  >
                                                    <div className="text-result pointer" style={{ marginTop: "55px", marginBottom: '55px' }}
                                                        onClick={() => {
                                                            // this.setState({
                                                            //     current: 1,
                                                            // })
                                                            this.prev()
                                                        }}>
                                                        <i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to Eagle Info
                                                    </div>
                                                </Col>

                                                <Col className='xs-center sm-center' xs={24} sm={24} md={8} lg={8} xl={8} offset={1}>
                                                    <FormItem>
                                                        <Button type="primary" style={{ width: '100%' }} className='submit-btn renew-search-btn' id="goToCart-btn" loading={this.props.giftLoading || this.props.loading || this.props.gettingShoppingcart || this.props.creatingPayments} onClick={() => this.handleRenewalSummary()} > Next</Button>
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Form>

                                </div>
                            }

                            {this.state.current == 3 &&
                                this.renderPaymentSummary()
                            }
                            {this.state.current == 4 &&
                                <div>
                                    <div className="centered steps-payment">
                                        <Row className='margin-top-30 payment-row' gutter={48} type="flex" justify="space-between" align="center">
                                            <Col xs={24} sm={24} md={24} lg={16} className="payment-col">
                                                <Card
                                                    className="margin-top-30"
                                                    title="Payment Information"

                                                >
                                                    <Row>
                                                        <Col span={10}>
                                                            <div className="checkbox-card-icon-wrapper">
                                                                <Row>
                                                                    <Col span={10}>
                                                                        <div className="title-txt margin-top-10" style={{ fontSize: '16px' }}>Credit Card</div>
                                                                    </Col>
                                                                    <Col span={10}>
                                                                        <img src='../credit-card.png' height={40} />
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Spin tip={`Please do not close the browser until the Receipt is displayed! \n  Redirecting in ${seconds} seconds...`} style={{ whiteSpace: "break-spaces" }} spinning={this.state.receipt_loading}>
                                                        {this.renderIframe()}
                                                    </Spin>
                                                </Card>
                                            </Col>

                                            <Col xs={24} sm={24} md={24} lg={8} className="payment-col">
                                                <Card
                                                    className="margin-top-30"
                                                    title="Summary"

                                                >
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={12}>
                                                            <span className="title-txt" style={{ fontSize: '16px' }}>Eagle Info</span>
                                                        </Col>
                                                        <Col span={12} className="right">
                                                            <span className="verified"><Icon type="check-circle" /> Verified</span>
                                                        </Col>
                                                        <Col span={24}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >{this.state.firstname} {this.state.middlename} {this.state.lastname} </span>
                                                        </Col>
                                                        <Col span={24}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >{this.state.memberId} </span>
                                                        </Col>
                                                    </Row>
                                                    <hr />
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={24}>
                                                            <span className="title-txt" style={{ fontSize: '16px' }}>Level</span>
                                                        </Col>

                                                        <Col span={18}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >{this.state.selectedMembershipType}</span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span className="summary-price" style={{ fontSize: '14px' }}>$ {this.state.remainingMembershipAmount}</span>
                                                        </Col>

                                                        {this.state.PromocodeApplied && <Row type="flex" justify="space-between" align="center" style={{ width: '100%' }}>
                                                            <Col span={18}>
                                                                <span className="label-txt green-txt" style={{ fontSize: '14px' }} ><CheckCircleTwoTone twoToneColor="#52c41a" /> {this.state.DiscountCode}</span>
                                                            </Col>
                                                            <Col span={6} className="right">
                                                                <span className="summary-price green-txt" style={{ fontSize: '14px' }}>-$ {this.state.DiscountAmount}</span>
                                                            </Col>
                                                        </Row>}

                                                        {this.state.PromocodeApplied && <Row style={{ width: '100%' }}>
                                                            <Col span={18}>
                                                                <div className="summary-label-txt" style={{ fontSize: '14px' }} >Membership Cost</div>
                                                            </Col>

                                                            <Col span={6} className="right">
                                                                <div className="summary-label-txt">${parseFloat(parseFloat(this.state.SelectedMembershipPrice) - parseFloat(this.state.DiscountAmount)).toFixed(2)}</div>
                                                            </Col>
                                                        </Row>}
                                                        {this.state.PromocodeApplied &&
                                                            <Divider style={{ margin: '10px 0px' }} />}

                                                        <Col span={18}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >{this.state.selectedMembershipType} S/H</span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span className="summary-price" style={{ fontSize: '14px' }}>$ {this.state.shipping_handlingCharge}</span>
                                                        </Col>

                                                    </Row>
                                                    {this.state.isPayTransactionFees && <Row type="flex" justify="space-between" align="center">
                                                        <Col span={18}>
                                                            <span className="label-txt" style={{ fontSize: '14px' }} >Transaction Fees</span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span className="summary-price" style={{ fontSize: '14px' }}>$ {this.state.transactionFee}</span>
                                                        </Col>
                                                    </Row>}
                                                    {/* {this.state.PromocodeApplied && <Row type="flex" justify="space-between" align="center">
                                                        <Col span={18}>
                                                            <span className="label-txt green-txt" style={{ fontSize: '14px' }} ><CheckCircleTwoTone twoToneColor="#52c41a" /> {this.state.DiscountCode}</span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span className="summary-price green-txt" style={{ fontSize: '14px' }}>-$ {this.state.DiscountAmount}</span>
                                                        </Col>
                                                    </Row> } */}
                                                    <hr />
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={12}>
                                                            <span className="title-txt" style={{ fontSize: '16px' }}>Total</span>
                                                        </Col>
                                                        <Col span={12}>
                                                            <span className="price-txt" style={{ fontSize: '14px' }}>${this.state.TotalAmount}</span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col className='xs-center sm-center' xs={24} sm={24} md={12} lg={12} xl={12}>
                                                <div className="steps-action centered">
                                                    <div className="text-result pointer"
                                                        style={{ marginTop: "55px", marginBottom: '55px' }}
                                                        onClick={() => {
                                                            // let total = (Math.round((parseFloat(this.state.needToPay) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
                                                            // this.setState({
                                                            //     ShowPaymentSummary: true,
                                                            //     isPayTransactionFees: false,
                                                            //     TotalAmount: total
                                                            // })
                                                            this.prev()

                                                        }}>
                                                        <i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to Eagle Info</div>
                                                </div>
                                                {/* <Button type="primary" className='back-btn' onClick={() => this.prev()}>Back to Step 2</Button> */}
                                            </Col>

                                        </Row>
                                    </div>
                                    {this.renderReceiptpage()}
                                </div>


                            }
                            {this.state.current == 5 &&
                                <div>
                                    <div className="centered steps-receipt">
                                        <Row gutter={48} type="flex" className='receipt-row'>
                                            <Col xs={24} sm={24} md={8} lg={8} className="margin-top-30 receipt-col">
                                                <Card
                                                    className=""
                                                >
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={24}>
                                                            <span className="title-txt">Summary</span>
                                                        </Col>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-high-txt">Name</span>
                                                            <span className="label-txt">
                                                                {this.state.firstname} {this.state.middlename} {this.state.lastname}</span>
                                                        </Col>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-high-txt">Date</span>
                                                            <span className="label-txt">{moment().format('MM/DD/YYYY')}</span>
                                                        </Col>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-high-txt">Address</span>
                                                            <span className="label-txt">
                                                                {this.state.address1 && (<React.Fragment>{this.state.address1}<br /></React.Fragment>)}
                                                                {this.state.address2 && (<React.Fragment>{this.state.address2}<br /></React.Fragment>)}
                                                                {this.state.address3 && (<React.Fragment>{this.state.address3}<br /></React.Fragment>)}
                                                                {this.state.city && this.state.userDetails.stateName && (<React.Fragment>{this.state.city}, {this.state.userDetails.stateName}<br /></React.Fragment>)}
                                                                {this.state.zip && (<React.Fragment>{this.state.zip}<br /></React.Fragment>)}
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                    <hr />
                                                    <Row>
                                                        <Col span={24} className='summary-block'>
                                                            <span className="label-txt"><b>{this.state.SelectedMembershipName}</b></span>
                                                        </Col>
                                                        <Col span={12} className=''>
                                                            <span className="title-txt">Total</span>
                                                        </Col>
                                                        <Col span={12} className='right'>
                                                            <span className="summary-price"><b>${this.state.TotalAmount}</b></span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col xs={24} sm={24} md={14} lg={14} className="margin-top-30 receipt-col">
                                                <Card
                                                    className="receipt-header"
                                                    title="National Eagle Scout Association"
                                                >
                                                    <Row type="flex" justify="space-between" align="center">
                                                        <Col span={24} className='right'>
                                                            <img src="../NESA.png" className='receipt-logo' />
                                                        </Col>
                                                        <Col>

                                                            <p>{RENEW_PURCHASE.PARAGRAPH1}</p>
                                                            <p>{RENEW_PURCHASE.PARAGRAPH2}</p>
                                                            <p>{RENEW_PURCHASE.PARAGRAPH3}</p>
                                                            <p>{RENEW_PURCHASE.PARAGRAPH4}</p>

                                                            <p>{RENEW_PURCHASE.PARAGRAPH5}<a href="mailto:NESA@scouting.org">NESA@scouting.org</a></p>

                                                        </Col>
                                                        <Col span={24} className="right signature-block">
                                                            <span>Yours in Scouting</span>
                                                            <img src='JohnStachniak_Signature.jpg' className='director-logo' />
                                                            <span><b>John Stachniak</b></span>
                                                            <span>Director, National Eagle Scout Association</span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col xs={24} sm={24} md={14} lg={14}>
                                                <Button type="primary" className='submit-btn' onClick={() => window.location.assign('https://nesa.org/')}>GO HOME</Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            }

                        </div>

                        <div className="steps-action centered">
                            {
                                this.state.current == 0
                                && <div className='membership-bottom'></div>
                            }
                        </div>
                    </div>
                </div>
                <NESAFooter />

                <Modal
                    className='multiple-r-modal'
                    title={false}
                    footer={false}
                    visible={this.state.showResultModal}
                    centered
                    onCancel={() => this.closeResult()}
                >
                    <div>
                        <span className='modal-header'>Multiple Records Found</span>
                        <span className='modal-desc'>Multiple records were found, please select one.</span>
                    </div>

                    {this.renderSearchResults()}

                    <Row type='flex' style={{ justifyContent: 'end', alignItems: 'center' }}>
                        <Col className='xs-center sm-center' xs={24} sm={24} md={24} lg={13} xl={13} >
                            <div className='step-container margin-top-20' >
                                <Button type="primary" className='back-btn' style={{ fontSize: '13px', width: '100%' }} onClick={() => this.NoResultsMatchMyProfileAlert()}>No Search Results Match My Profile</Button>
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5} offset={2}>
                            <div className='step-container margin-top-20' >
                                <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                    // this.props.actions.getProfileInfo(this.state.selectedRecord.personGuid)
                                    // this.props.actions.getAlumniEagleInfo(this.state.selectedRecord.personGuid)
                                    this.closeResult();
                                    this.setState({
                                        current: this.state.current + 1
                                    })
                                    this.props.actions.getNESARegistrations(this.state.personGUID, true);
                                }} htmlType='submit'>SELECT</Button>
                            </div>
                        </Col>
                    </Row>
                </Modal>
                <Modal
                    className='No-records-match-myMrofile-model'
                    title={false}
                    footer={false}
                    visible={this.state.NoResultsMatchProfile}
                    centered
                    onCancel={() => this.closeNorecordsMatchProfile()}
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                        <div className='No-Results-Match-Pro'>
                            No Results Match Profile
                        </div>

                        <div className='margin-bottom-20'> Whoops! It appears no current Eagle Scout record matches your Eagle Scout information. Please confirm the Eagle Scout MemberID and try again.</div>
                        <div>Alternatively, please contact the Scout's Eagle Scout council for further assistance.</div>

                        <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                                <div className='step-container margin-top-20' >
                                    <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                        this.closeNorecordsMatchProfile();
                                    }} htmlType='submit'>CLOSE </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>
                <Modal
                    className='No-records-Found-model'
                    style={{ width: '600px' }}
                    title={false}
                    footer={false}
                    visible={this.state.NoResultsFound}
                    centered
                    onCancel={() => this.close_NoResultsFound_Modal()}
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                        <div className='No-Results-Match-Pro'>
                            Missing Information
                        </div>

                        {/* <div className='margin-bottom-20'> Whoops! We found the Scout but there wasn't any Eagle Scout information associated with them.  Please confirm the Eagle Scout MemberID and try again.</div>
                        <div>Alternatively, please contact the Eagle Scout council for further assistance.</div> */}

                        <div className="margin-bottom-20"> Whoops! it appears there is critical information regarding First Name, Last Name or Date of Birth, missing from your Eagle Scout record. </div>
                        {/* <div style={{ color: ' #cc0033', marginBottom: '10px' }}>
                            Firstname, Lastname, Date of Birth
                        </div>
                        <div> please contact your Eagle Scout council for further assistance.</div>
                        <div style={{ backgroundColor: "#fce4e4", border: '2px solid #fcc2c3', padding: '10px 20px', margin: '10px 0px', color: ' #cc0033' }}>
                            Missing or incomplete ID records in Akela (the master membership database)
                        </div> */}

                        <div> Please contact your Eagle Scout council to update your Eagle information. </div>

                        <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                                <div className='step-container margin-top-20' >
                                    <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                        this.close_NoResultsFound_Modal();
                                    }} htmlType='submit'>CLOSE </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>
                <Modal
                    className='No-records-Found-model'
                    style={{ width: '600px' }}
                    title={false}
                    footer={false}
                    visible={this.state.NoMembershipFound_Modal}
                    centered
                    onCancel={() => this.close_NoMembershipFound_Modal()}
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                        <div className='No-Results-Match-Pro'>
                            No Eagle Scout Membership found!
                        </div>

                        {/* <div className='margin-bottom-20'> Whoops! We found the Scout but there wasn't any Eagle Scout information associated with them.  Please confirm the Eagle Scout MemberID and try again.</div>
                        <div>Alternatively, please contact the Eagle Scout council for further assistance.</div> */}

                        <div > It appears there is no current membership plan under the following applicant
                            to renew. </div>


                        <div> Please purchase a new membership.</div>

                        <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                                <div className='step-container margin-top-20' >
                                    <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                        this.close_NoMembershipFound_Modal();
                                    }} htmlType='submit'>CLOSE </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>

                <Modal
                    centered
                    className='ExistingLifeTimePlanModal'
                    visible={this.state.existingLifePlan}
                    closable={false}
                    footer={
                        <Button key="submit" type="primary" className='RedirectExistingLifePlan'
                            onClick={this.closeExistingLifePlanModal}>
                            Close
                        </Button>
                    }
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>

                        <div className='Existing-Lifeplan-Info'>
                            <span className='modal-desc'>You already have an existing NESA Lifetime plan. </span>
                        </div>
                    </div>
                </Modal>


                {this.state.isShow_MissingFieldsPopup && <Modal
                    className="multiple-r-modal"
                    title={false}
                    footer={false}
                    visible={this.state.isShow_MissingFieldsPopup}
                    centered
                    onCancel={() => this.closeMissingFieldsPopup()}
                    style={{ width: '500px' }}
                >

                    <Row type="flex" align="left">
                        <Col xs={24}>
                            <div >
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                    <img src={warningAlert} width="25px" height="25px" style={{ marginRight: '10px' }} />
                                    <span className="modal-header">Missing Information</span>
                                </div>
                                <div className="modal-desc" style={{ margin: '10px 0px' }}>
                                    It appear required information is missing "Scout's Email" {/* [list missing field here]. */} Please update that information in order to complete your
                                    application process.
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Form onSubmit={this.handleSubmit_MissingField} className="Scout-email-form alumni-ui">
                        {/* <Col className="card-margin search-alumni" span={24}> */}
                        {/* <Card
                                className="centered"
                                title="Scout's Missing Information"
                            > */}
                        <Row type="flex" align="center" className="center" style={{ textAlign: 'left' }} >
                            {/* <div className="center"> */}

                            <Col xs={24} sm={24} md={12} lg={12} xl={8}  >
                                <FormItem hasFeedback label="Scout's Email" style={{ width: '100%' }}>
                                    {getFieldDecorator("email", {
                                        rules: [
                                            {
                                                required: true,
                                                type: "email",
                                                message: "Enter valid email address!",
                                            },
                                        ],
                                    })(<Input placeholder="Email" />)}
                                </FormItem>
                            </Col>
                            {/* </div> */}
                        </Row>



                        <Row type="flex" align="center" justify="end">
                            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                                <div className="step-container " style={{ margin: '0px' }}>
                                    <FormItem >
                                        <Button
                                            type="primary"
                                            className="submit-btn"
                                            htmlType="submit"
                                            style={{ margin: '0px' }}
                                        //   onClick={() => {}}
                                        >

                                            NEXT
                                        </Button>
                                    </FormItem>
                                </div>
                            </Col>
                        </Row>
                        {/* </Card> */}
                        {/* </Col> */}
                    </Form>


                </Modal>
                }

                <Modal
                    centered
                    className='IneligibleApplicantModal'
                    visible={this.state.ShowIneligibleStatus}
                    onCancel={this.closeIneligibleStatusModal}
                    title="Whoops!"
                    footer={
                        <Button key="submit" type="primary" className="RedirectIneligibleToNESA"
                            onClick={this.CloseIneligibleToDashboard}>
                            Close
                        </Button>
                    }
                >
                    It appears there is a question of your NESA membership eligibility.
                    Please contact your local council for more detailed information.
                </Modal>

                {/* {this.state.doesShowNewMemberGreetings && <NewEagleGreetingsModal 
                doesShowNewMemberGreetingsProps={this.state.doesShowNewMemberGreetings} 
                closeNewMemberGreetingsModalHandler={this.closeNewMemberGreetingsModal} 
                />} */}

                <CustomPopupModal
                    doesShowPopup={this.state.isDeceasedPerson}
                    closePopup={this.closeDeceasedPersonPopup}
                    popupTitle={"Invalid Membership Purchase"}
                    popupPrimaryContent={deceasedPopup_primaryConent}
                    popupSecondaryContent={deceasedPopup_secondaryConent} 
                    />

                {this.state.showLookupError && <CustomPopupModal 
                doesShowPopup={this.state.showLookupError} 
                closePopup={this.retryToLoadFailedLookups} 
                popupTitle={"Internal Server Error"} 
                btnText={"RETRY"} 
                popupPrimaryContent={`${failedToLoadLookup_Popup_primaryConent} "${this.state.failedLookups.join(', ')}" lookup data `}
                popupSecondaryContent={failedToLoadLookup_secondaryConent} 
                />
}
                

                <FullPageSpinner spinning={this.state.pageLoader}/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        loggingIn: state.authenticationReducer.loggingIn,
        timeout: state.authenticationReducer.timeout,
        initloading: state.chasepaymentreducer.loading,
        initTransaction: state.chasepaymentreducer.initTransaction,
        ethnicities_loading: state.ethnicitiesreducer.loading,
        ethnicities: state.ethnicitiesreducer.ethnicities,
        paymentstatus: state.paymentcompletedreducer.status,
        productprice: state.productpricereducer.productprice,
        productprice_loading: state.productpricereducer.loading,
        nesa_levels_loading: state.nesalevelsreducer.loading,
        nesa_levels: state.nesalevelsreducer.levels,
        allstates: state.allstatesreducer.states,
        loading: state.purchasemembershipreducer.loading,
        response: state.purchasemembershipreducer.response,
        regstatus: state.regstatusreducer.status,
        regError: state.regstatusreducer.regError, 
        searching: state.eagleSearchReducer.searching,
        searchedEagle: state.eagleSearchReducer.eagle,
        countries: state.countriesreducer.countries,
        phonecode: state.phonecountrycodereducer.code,
        registration_loading: state.purchasemembershipreducer.loading,
        nesa_loading: state.nesaregistrationreducer.loading,
        nesa_reg: state.nesaregistrationreducer.reg,
        applingPromocode: state.promocodereducer.loading,
        PromocodeAdded: state.promocodereducer.response,
        PromocodeRemoved: state.promocodereducer.removedPromoAmount,
        PromocodeError: state.promocodereducer.error,
        creatingPayments: state.PaymentsCreateReducer.loading,
        createdPayments: state.PaymentsCreateReducer.response,
        gettingShoppingcart: state.shoppingCartReducer.loading,
        shoppingCartList: state.shoppingCartReducer.response,
        giftLoading: state.giftmembershipreducer.loading,
        giftResponse: state.giftmembershipreducer.response,

        ethnicitiesError: state.ethnicitiesreducer.error,
        productpriceError: state.productpricereducer.error,
        nesa_levelsError: state.nesalevelsreducer.error,
        allstatesError: state.allstatesreducer.error,
        countriesError: state.countriesreducer.error,
        phonecodeError: state.phonecountrycodereducer.error, 
        regError: state.regstatusreducer.regError,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) }
}

const RenewMembership = Form.create()(RenewMembershipForm);

export default connect(mapStateToProps, mapDispatchToProps)(RenewMembership);


// WEBPACK FOOTER //
// ./src/components/Membership/RenewMembership.js